import React, { useState, useMemo, useCallback } from "react";
import {
  BsCheckLg,
  BsDash,
  BsDashCircle,
  BsExclamationTriangle,
  BsPencilSquare,
  BsPlus,
  BsPlusCircle,
} from "react-icons/bs";
import { BiHide } from "react-icons/bi";
import { PiNotebookBold } from "react-icons/pi";
import { cloneDeep, debounce, get } from "lodash";
import { DiliTextCP } from "../Utility/DiliTextCP";
import {
  // CDKOrderEditingRules,
  calculateValueCovered,
  codOptions,
  getInsuranceFee,
  newPieceTypes,
  // newPieceTypesValueMap,
  // pieceTypes,
  viewStates,
} from "../../constants";
import { Modal, OverlayTrigger } from "react-bootstrap";
import { useEffect } from "react";
import { CDKOrderDetailsPanel } from "./CDKOrderDetailsPanel";
import { PageLoadError } from "../Utility/PageLoadError";
import SortArrow from "../Utility/SortArrow";
import handleApiError from "../../helpers/handleApiError";
import { useHistory } from "react-router-dom";
import {
  // getCitiesForState,
  getTimeCodesForCityAndStateAndZip,
} from "../../services/customerService";
import jwtDecode from "jwt-decode";
import { tokenKeyName } from "../../config";
import { toast } from "react-toastify";
import {
  // CapitalizeCity,
  assembleCityStateZipWithNotFound,
  // capitalizeFirstLetter,
  // isValidAddress,
  isValidCDKOrderSubmission,
  sleep,
} from "../../helpers/utilities";
import {
  changeCDKOrdersHiddenStatus,
  postCDKOrder,
  postMergedCDKOrder,
  updateCDKOrderIsImportedField,
} from "../../services/cdkOrderService";
import PDFObject from "pdfobject";
import {
  getLabelsForCDKDeliveries,
  // getLabelsForMultipleDeliveries,
} from "../../services/deliveryService";
import { isClient } from "../../services/accountService";
// import { FaTrashRestore } from "react-icons/fa";
import { TbArrowMerge } from "react-icons/tb";
import { useRef } from "react";
import { LoadingSpinner } from "../Utility/LoadingSpinner";
import Chips from "../Utility/Chips";
import { CDKGuideAccordionCard } from "./CDKGuideAccordionCard";
import { TooltipStandard } from "../Utility/TooltipStandard";
import { EditCDKCustomerModal } from "./EditCDKCustomerModal";
const finalizationModalStates = {
  hidden: "hidden",
  finalizingOrder: "finalizingOrder",
  labelsRetrieved: "labelsRetrieved",
  error: "error",
};
const commentLimit = 495;
const GuideModal = ({ show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>CDK Order Import Guide</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="p-2 bg-gray">
          <div className="panel-flat pt-2 px-2">
            <h5 className="ml-1">Merge Guidelines</h5>
            <hr className="mb-0" />
            <div
              className="py-4 px-2 custom-scrollbar"
              style={{ maxHeight: "450px", overflowY: "auto" }}
            >
              <CDKGuideAccordionCard
                title={<h6 className="mb-0">Merge Criteria</h6>}
                eventKey="mergeCriteria"
                openByDefault={false}
                containerClass="mb-2"
              >
                <div className="px-2">
                  <ul>
                    <li className="mt-2">
                      Destinations
                      <ul>
                        <li>
                          Selected shipments must go to the{" "}
                          <span className="font-600">same destination</span>
                        </li>
                      </ul>
                    </li>
                    <li className="mt-2">
                      Piece Types
                      <ul>
                        <li className="mt-2">Can Merge</li>
                        <ul>
                          <li>Package to Package</li>
                          <li>Package to Pallet</li>
                          <li>
                            <span className="font-600">
                              Any shipment piece type can be merged
                            </span>{" "}
                            with any other piece type if shipments have{" "}
                            <span className="font-600">
                              at least one Package Type
                            </span>
                            <ul>
                              <li>
                                E.g. Shipments with Pallet/Transmission/Engine
                                Types may be combined with other shipments with
                                Pallet/Transmission/Engine Types if they both
                                have at least one Package Type
                              </li>
                            </ul>
                          </li>
                        </ul>
                        <li className="mt-2">Cannot Merge</li>
                        <ul>
                          <li>Pallet to Pallet</li>
                          <li>Transmission to Transmission</li>
                          <li>Engine to Engine</li>
                          <li>Transmission to Engine or vice versa</li>
                        </ul>
                      </ul>
                    </li>
                  </ul>
                </div>
              </CDKGuideAccordionCard>

              <CDKGuideAccordionCard
                title={<h6 className="mb-0">How To</h6>}
                eventKey="howTo"
                openByDefault={false}
                containerClass="mb-2"
              >
                <div className="px-2">
                  <ul>
                    <li className="mt-2">Merge Shipments</li>
                    <ol>
                      <li>Select the shipments you wish to merge</li>
                      <li>
                        Configure piece types and label quantities before
                        merging
                        <ul>
                          <li>
                            Only the number of labels for Package Type may be
                            modified after the merge but not the number of
                            labels for any other piece types
                          </li>
                        </ul>
                      </li>
                      <li>
                        Select "Merge Selected"
                        <ul>
                          <li>
                            The merged shipments will now have an "Unmerge"
                            button next to the "Finalize" button
                          </li>
                        </ul>
                      </li>
                      <li>
                        You may now finalize the merged shipments as a regular
                        order
                      </li>
                    </ol>
                    <li className="mt-2">
                      Unmerge shipments
                      <ol>
                        <li>
                          Select the "Unmerge" button next to the "Finalize"
                          button
                          <ul>
                            <li>
                              This will undo the merge and return the shipments
                              to their original state
                            </li>
                          </ul>
                        </li>
                      </ol>
                      <span className="font-600">
                        *Once finalized, shipments may not be unmerged.{" "}
                      </span>
                    </li>
                  </ul>
                </div>
              </CDKGuideAccordionCard>

              <CDKGuideAccordionCard
                title={<h6 className="mb-0">Vocabulary</h6>}
                eventKey="vocabulary"
                openByDefault={false}
              >
                <div className="px-2">
                  <ul>
                    <li className="mt-2">
                      Shipment
                      <ul>
                        <li>
                          A shipment is a CDK row line item that is pending
                          finalization to be imported as a Diligent order.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </CDKGuideAccordionCard>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" type="button" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};
const MultiFinalizeModal = ({
  show,
  onHide,
  ordersToFinalize,
  multiUpdateCDKOrderMainFields,
}) => {
  const multiFinalizeViewStates = {
    default: "default",
    finalizing: "finalizing",
    finalized: "finalized",
  };
  const [viewState, setViewState] = useState(multiFinalizeViewStates.default);
  //Must add VALIDATION here for multi finalize modal.
  let ordersWithIssuesCount = 0;
  let ordersWithNoTimeCodeCount = 0;
  let ordersWithNegativeDeclaredValueCount = 0;
  let CODOrdersWithNoValueEnteredCount = 0;
  for (let i = 0; i < ordersToFinalize.length; i++) {
    // if (
    //   ordersToFinalize[i].dataToSubmit.timeCode === "" ||
    //   ordersToFinalize[i].dataToSubmit.shipments.filter(
    //     (shipment) => shipment.declaredValue < 0
    //   ).length > 0
    // ) {
    // ordersWithIssuesCount += 1;
    let shouldUpdateOrdersWithIssueCount = false;
    if (ordersToFinalize[i].dataToSubmit.timeCode === "") {
      ordersWithNoTimeCodeCount += 1;
      // ordersWithIssuesCount += 1;
      shouldUpdateOrdersWithIssueCount = true;
    }
    if (
      ordersToFinalize[i].dataToSubmit.shipments.filter(
        (shipment) => shipment.declaredValue < 0
      ).length > 0
    ) {
      ordersWithNegativeDeclaredValueCount += 1;
      // ordersWithIssuesCount += 1;
      shouldUpdateOrdersWithIssueCount = true;
    }
    if (
      ordersToFinalize[i].dataToSubmit.shipments.filter(
        (shipment) =>
          shipment.CODType !== codOptions.None.value &&
          shipment.declaredValue <= 0
      ).length > 0
    ) {
      CODOrdersWithNoValueEnteredCount += 1;
      // ordersWithIssuesCount += 1;
      shouldUpdateOrdersWithIssueCount = true;
    }
    if (shouldUpdateOrdersWithIssueCount) {
      ordersWithIssuesCount += 1;
    }
    // }
  }
  const ordersHaveIssues =
    ordersWithNoTimeCodeCount > 0 ||
    ordersWithNegativeDeclaredValueCount > 0 ||
    CODOrdersWithNoValueEnteredCount > 0;
  // const ordersWithNoTimeCode = ordersToFinalize.filter((order) => {
  //   return order.dataToSubmit.timeCode === "";
  // });
  // const ordersWithNegativeDeclaredValue = ordersToFinalize.filter(order=>{
  //   return order.dataToSubmit.shipments.filter(shipment=>shipment.declaredValue < 0)
  // })
  const [ordersToFinalizeWithoutIssues, setOrdersToFinalizeWithoutIssues] =
    useState([]);
  const [finalizationResults, setFinalizationResults] = useState([]);
  const [finalizationStatistics, setFinalizationStatistics] = useState({
    success: 0,
    fail: 0,
  });
  const handleClickFinalize = async () => {
    //set up next modal phase
    setViewState(multiFinalizeViewStates.finalizing);
    const ordersToActuallyFinalize = ordersToFinalize.filter((order) => {
      // return (
      //   order.dataToSubmit.timeCode !== "" &&
      //   order.dataToSubmit.shipments.filter(
      //     (shipment) => shipment.declaredValue < 0
      //   ).length === 0
      // );
      return isValidCDKOrderSubmission(order).isValid;
    });
    setOrdersToFinalizeWithoutIssues(ordersToActuallyFinalize);
    //make post calls:
    const orderPromises = ordersToActuallyFinalize.map((order, index) => {
      const orderBody = {
        deliveryId: 0,
        CdkOrderId: order.CDKOrderID,
        invoiceNumber: order.dataToSubmit.invoiceNumber,
        customerName: order.dataToSubmit.customerName,
        customerAddress: order.dataToSubmit.customerAddress.address,
        customerCity: order.dataToSubmit.customerAddress.city,
        customerStateAbbreviation: order.dataToSubmit.customerAddress.state,
        customerZipCode: order.dataToSubmit.customerAddress.zip,
        customerPhoneNumber: "",
        pieceCount: order.dataToSubmit.shipments[0].numShippingLabels,
        pieceType: order.dataToSubmit.shipments[0].pieceType,
        amount: order.dataToSubmit.shipments[0].declaredValue,
        comment: order.dataToSubmit.shipments[0].comments,
        codType: order.dataToSubmit.shipments[0].CODType,
        timeCode: order.dataToSubmit.timeCode,
        wantsValuationCoverage: order.dataToSubmit.shipments[0].insurance,
        refNo: "CDK",
        dropShipClientId: "",
        // customerId: 0,
        Cod_Default: false,
        Cash_Default: false,
        isDefaultChecked: false,
        weight: 0,
        PieceTypeList: order.dataToSubmit.shipments.slice(1).map((shipment) => {
          return {
            numPieces: shipment.numShippingLabels,
            pieceTypeString: shipment.pieceType,
            amount: shipment.declaredValue,
            cType: shipment.CODType,
            coverage: shipment.insurance,
            comments: shipment.comments,
          };
        }),
      };
      if (order.isMergedOrder) {
        orderBody.combinationInvoicesList = order.mergedInvoiceDetails;
      }
      const postOrderFunction = order.isMergedOrder
        ? postMergedCDKOrder
        : postCDKOrder;
      //staggering/delay api calls by 5ms - not sure if this is good or not, just thinking it might be better to not send them allll at once
      return sleep(index * 5).then(() => {
        return postOrderFunction(orderBody)
          .then((res) => {
            // setFinalizationResults((prevResults) => [...prevResults, res.data]); //don't really need to update this as we can just use the data from Promise.allSettled, with only 1 rerender
            //after successfully posting, update the order's isImported field to true on the backend.
            //we'll update the frontend value of isImported for each order all at once when everything is done. (We do this to keep things in sync without having to reload the page)
            updateCDKOrderIsImportedField({ Id: [order.CDKOrderID] });
            //update success statistic
            setFinalizationStatistics((prev) => {
              return {
                ...prev,
                success: prev.success + 1,
              };
            });
            return {
              success: true,
              invoice: order.dataToSubmit.invoiceNumber,
              CDKOrderID: order.CDKOrderID,
              isMergedOrder: order.isMergedOrder,
              data: res.data,
            };
          })
          .catch((ex) => {
            setFinalizationStatistics((prev) => {
              return {
                ...prev,
                fail: prev.fail + 1,
              };
            });
            return {
              success: false,
              data: ex?.response?.status ?? "Unidentified",
            };
          });
      });
    });

    //use promise.allsettled to wait for all post order requests to finish, and then move to phase 3 of the modal (viewing and printing labels)

    Promise.allSettled(orderPromises).then((settled) => {
      // console.log("all settled result: ", settled);
      setFinalizationResults(settled);
      // console.log(
      //   settled
      //     .filter((result) => result.value.success)
      //     .map((result) => result.value.CDKOrderID)
      // );
      // console.log("settled response from multi finalize post", settled);
      multiUpdateCDKOrderMainFields(
        //pass in the cdk order ids of the orders that were posted successfully
        settled
          .filter((result) => result.value.success)
          .map((result) => result.value),
        "isImported",
        true
      );
      setViewState(multiFinalizeViewStates.finalized);
    });
  };
  // console.log(finalizationResults);
  const successfulResults = finalizationResults.filter(
    (result) => result.value.success
  );
  const failedResults = finalizationResults.filter(
    (result) => !result.value.success
  );

  const history = useHistory();

  const [viewingAllLabels, setViewingAllLabels] = useState(false);
  const [invoiceOfLabelToView, setInvoiceOfLabelsToView] = useState("");
  const [labelPDFToView, setLabelPDFToView] = useState();
  const [loadingLabels, setLoadingLabels] = useState(false);

  const handleClickViewLabel = async (e, invoice) => {
    setViewingAllLabels(false);
    setInvoiceOfLabelsToView(invoice);
    const invoiceResult = successfulResults.find((result) => {
      return result.value.invoice === invoice;
    });
    // console.log("invoice delivery data: ", invoiceResult);
    const associatedDeliveryIDs = invoiceResult.value.data.map((subOrder) => {
      return subOrder.deliveryId;
    });
    try {
      setLoadingLabels(true);
      const labelResponse = await getLabelsForCDKDeliveries(
        associatedDeliveryIDs.join(","),
        false,
        isClient()
      );
      const reader = new FileReader();
      reader.readAsDataURL(labelResponse.data);
      reader.onloadend = () => {
        setLabelPDFToView(reader.result);
        PDFObject.embed(reader.result, "#multifinal-pdf-container");
      };
    } catch (ex) {
      handleApiError(ex, history);
    } finally {
      setLoadingLabels(false);
    }
  };

  const handleClickViewAllLabels = async (e) => {
    setViewingAllLabels(true);
    setInvoiceOfLabelsToView("");
    let deliveryIDs = [];
    for (let i = 0; i < finalizationResults.length; i++) {
      for (let j = 0; j < finalizationResults[i].value?.data?.length; j++) {
        deliveryIDs.push(finalizationResults[i].value?.data?.[j]?.deliveryId);
      }
    }
    try {
      setLoadingLabels(true);
      const labelResponse = await getLabelsForCDKDeliveries(
        deliveryIDs.join(","),
        false,
        isClient()
      );
      const reader = new FileReader();
      reader.readAsDataURL(labelResponse.data);
      reader.onloadend = () => {
        setLabelPDFToView(reader.result);
        PDFObject.embed(reader.result, "#multifinal-pdf-container");
      };
    } catch (ex) {
      handleApiError(ex, history);
    } finally {
      setLoadingLabels(false);
    }
  };

  const handleCloseLabelViewer = (e) => {
    onHide(); //sets show to false from parent
    setViewState(multiFinalizeViewStates.default);
    setFinalizationResults([]);
    setFinalizationStatistics({ success: 0, fail: 0 });
    setViewingAllLabels(false);
    setInvoiceOfLabelsToView("");
    setLabelPDFToView();
  };

  return (
    <>
      <Modal
        show={show && viewState === multiFinalizeViewStates.default}
        onHide={onHide}
        // backdrop="static"
        centered
      >
        <Modal.Header>
          <Modal.Title style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>
                {`Finalize ${ordersToFinalize.length} Order${
                  ordersToFinalize.length > 1 ? "s" : ""
                }`}{" "}
              </div>
              {ordersHaveIssues && (
                <div>
                  <BsExclamationTriangle
                    color="red"
                    size="1.5rem"
                    style={{ marginTop: "-.5rem", marginRight: ".3rem" }}
                  />
                </div>
              )}
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {ordersHaveIssues ? (
            <>
              <div className="font-600">
                Some orders have issues and will not be finalized:{" "}
              </div>
              <div>
                {ordersWithNoTimeCodeCount > 0
                  ? `${ordersWithNoTimeCodeCount} order${
                      ordersWithNoTimeCodeCount > 1 ? "s have" : " has"
                    } no time code selected.`
                  : ""}
              </div>
              <div>
                {ordersWithNegativeDeclaredValueCount > 0
                  ? `${ordersWithNegativeDeclaredValueCount} order${
                      ordersWithNegativeDeclaredValueCount > 1
                        ? "s have"
                        : " has"
                    } shipments with a negative declared value.`
                  : ""}
              </div>
              <div>
                {CODOrdersWithNoValueEnteredCount > 0
                  ? `${CODOrdersWithNoValueEnteredCount} order${
                      CODOrdersWithNoValueEnteredCount > 1 ? "s have" : " has"
                    } COD shipments with no declared value.`
                  : ""}
              </div>
              <div className="text-note font-small mt-3">
                Multiple issues may apply to the same order.
              </div>
            </>
          ) : (
            <div>No issues detected. All selected orders may be finalized.</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-secondary" onClick={onHide}>
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleClickFinalize}
            disabled={ordersToFinalize.length - ordersWithIssuesCount === 0}
          >
            {ordersHaveIssues
              ? `Finalize Rest (${
                  ordersToFinalize.length - ordersWithIssuesCount
                })`
              : "Finalize"}
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={viewState === multiFinalizeViewStates.finalizing}
        onHide={onHide}
        backdrop="static"
        centered
      >
        <Modal.Header>
          <Modal.Title style={{ width: "100%" }}>
            {`Finalizing ${ordersToFinalizeWithoutIssues.length} Order${
              ordersToFinalizeWithoutIssues.length > 1 ? "s" : ""
            }`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              display: "grid",
              placeContent: "center",
              textAlign: "center",
              padding: "1.5rem",
            }}
          >
            <div>
              <div className="spinner-border p-3 mb-3" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <div>{`${finalizationStatistics.success}/${ordersToFinalizeWithoutIssues.length} orders finalized successfully`}</div>
              <div>{`${finalizationStatistics.fail}/${ordersToFinalizeWithoutIssues.length} orders failed`}</div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={viewState === multiFinalizeViewStates.finalized}
        // show={true}
        backdrop="static"
        size="xl"
      >
        <Modal.Header>
          <Modal.Title>{`Finalized ${finalizationStatistics.success}/${ordersToFinalizeWithoutIssues.length} orders successfully`}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: 0 }}>
          <div className="row">
            <div className="col-md-3 pr-md-0">
              <div
                className="cdk-multifinal-modal-subheader"
                style={{ borderRight: "1px solid #dee2e6" }}
              >
                Invoices
              </div>
              <div
                style={{
                  height: "75dvh",
                  overflow: "auto",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                {successfulResults.length > 1 && (
                  <div
                    className={
                      "cdk-multifinal-modal-invoice-container" +
                      (viewingAllLabels ? " table-active" : "")
                    }
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    All
                    <button
                      type="button"
                      className="btn btn-primary px-2"
                      onClick={handleClickViewAllLabels}
                    >
                      View All
                    </button>
                  </div>
                )}
                {successfulResults.map((result, index) => {
                  {
                    /* {Array.from({ length: 100 }).map((element, index) => {
                  const result = { value: { invoice: index } }; */
                  }
                  return (
                    <div
                      key={index + "-" + result.value.invoice}
                      className={
                        "cdk-multifinal-modal-invoice-container" +
                        (result.value.invoice === invoiceOfLabelToView
                          ? " table-active"
                          : "")
                      }
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          style={{
                            wordBreak: "break-all",
                            paddingRight: "1em",
                          }}
                        >
                          {result.value.invoice +
                            (result.value.isMergedOrder ? " (Multi)" : "")}
                        </div>
                        <button
                          type="button"
                          className="btn btn-primary px-2"
                          onClick={(e) => {
                            handleClickViewLabel(e, result.value.invoice);
                          }}
                        >
                          View Labels
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="col-md-9 pl-md-0">
              <div className="cdk-multifinal-modal-subheader">Labels</div>
              <div
                style={{
                  backgroundColor: "#525659",
                }}
              >
                {!viewingAllLabels && !invoiceOfLabelToView && (
                  <div
                    style={{
                      height: "75dvh",
                      display: "grid",
                      placeContent: "center",
                      color: "white",
                    }}
                  >
                    Select a label to view
                  </div>
                )}
                {loadingLabels && (
                  <LoadingSpinner
                    containerStyleAppend={{
                      height: "75dvh",
                      display: "grid",
                      placeContent: "center",
                      color: "white",
                      backgroundColor: "#525659",
                    }}
                  />
                )}
                <div
                  id="multifinal-pdf-container"
                  style={{
                    height: "75dvh",
                    display:
                      loadingLabels ||
                      (!viewingAllLabels && !invoiceOfLabelToView)
                        ? "none"
                        : "block",
                  }}
                ></div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleCloseLabelViewer}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const FinalizeOrderModal = ({ viewState, onHide, cdkOrder, labels }) => {
  const [labelsState, setLabelsState] = useState();
  // const [forceUpdate, setForceUpdate] = useState(0);
  // console.log(labels);
  useEffect(() => {
    if (viewState === finalizationModalStates.labelsRetrieved) {
      PDFObject.embed(labels, "#pdf-container");
      // setTimeout(() => {
      //   setForceUpdate((prev) => prev + 1);
      // }, 5000);
    }
  }, [viewState]);

  return (
    <>
      <Modal
        show={viewState === finalizationModalStates.finalizingOrder}
        onHide={onHide}
        backdrop="static"
        centered
      >
        <Modal.Body>
          <div
            style={{
              display: "grid",
              placeContent: "center",
              textAlign: "center",
              padding: "1.5rem",
            }}
          >
            <div>
              <div className="spinner-border p-3 mb-3" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <div>Finalizing Order</div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={viewState === finalizationModalStates.labelsRetrieved}
        onHide={onHide}
        backdrop="static"
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Finalized Invoice {cdkOrder?.dataToSubmit?.invoiceNumber}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div id="pdf-container" style={{ height: "75dvh" }}></div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-secondary" onClick={onHide}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const HideCDKOrderConfirmModal = ({ show, onHide, cdkOrder, hideCDKOrder }) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          Hide Invoice {cdkOrder?.dataToSubmit?.invoiceNumber}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure you want to hide this order?</Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onHide}>
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => {
            hideCDKOrder(cdkOrder);
          }}
        >
          Hide
        </button>
      </Modal.Footer>
    </Modal>
  );
};

const HideMultiCDKOrderConfirmModal = ({
  show,
  onHide,
  selectedOrders,
  handleHideSelectedCDKRows,
}) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header>
        <Modal.Title>Hiding Multiple Invoices</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you wish to hide {selectedOrders.length} selected orders?
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onHide}>
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-danger"
          onClick={() => {
            handleHideSelectedCDKRows(
              // selectedOrders.map((order) => {
              //   // console.log(order);
              //   return order.CDKOrderID;
              // })
              selectedOrders
            );
            onHide();
          }}
        >
          Yes
        </button>
      </Modal.Footer>
    </Modal>
  );
};

// const displayPieceType = (numLabels, pieceType) => {
//   console.log("numlabels display function", numLabels);
//   return (
//     numLabels +
//     " " +
//     newPieceTypes[newPieceTypesValueMap[pieceType]].display +
//     (numLabels > 1 &&
//     !newPieceTypes[newPieceTypesValueMap[pieceType]].staysSingular
//       ? "s"
//       : "")
//   );
// };

// const mergeOrderViewTypes = {
//   byInvoice: "By Invoice",
//   byPieceType: "By Piece Type",
// };
// const MergeSelectedOrdersModal = ({
//   show,
//   onHide,
//   ordersToMerge,
//   multiUpdateCDKOrderMainFields,
// }) => {
//   const [initialMergedComments, setInitialMergedComments] = useState(() => {});

//   const [mergeViewType, setMergeViewType] = useState(
//     mergeOrderViewTypes.byInvoice
//   );

//   const handleSelectMergeViewType = (viewType) => {
//     setMergeViewType(viewType);
//   };

//   const [timeCode, setTimeCode] = useState();
//   const handleChangeTimeCode = (e) => {
//     console.log(e.target.value);
//   };

//   console.log("orders to merge: ", ordersToMerge);
//   let newPieceTypeValues = Object.values(newPieceTypes).map(
//     (pieceTypeObject) => pieceTypeObject.value
//   );
//   let ordersByPieceType = newPieceTypeValues.reduce((rolling, current) => {
//     console.log(rolling);
//     console.log(current);
//     rolling[current] = { invoiceNumbers: [], numShippingLabels: 0 };
//     return rolling;
//   }, {});
//   console.log("ordersByPieceType...", ordersByPieceType);
//   ordersByPieceType =
//     ordersToMerge.length > 0
//       ? ordersToMerge.reduce((ordersByPieceTypeBuilder, currentOrder) => {
//           for (let i = 0; i < currentOrder.dataToSubmit.shipments.length; i++) {
//             const currentShipment = currentOrder.dataToSubmit.shipments[i];
//             console.log("1....", ordersByPieceTypeBuilder);
//             console.log("2....", currentShipment.pieceType);
//             console.log("3....", ordersByPieceTypeBuilder[""].invoiceNumbers);
//             console.log(
//               "currentshipment num labels",
//               currentShipment.numShippingLabels
//             );
//             ordersByPieceTypeBuilder[currentShipment.pieceType].invoiceNumbers =
//               [
//                 ...ordersByPieceTypeBuilder[currentShipment.pieceType]
//                   .invoiceNumbers,
//                 currentOrder.dataToSubmit.invoiceNumber,
//               ];
//             ordersByPieceTypeBuilder[
//               currentShipment.pieceType
//             ].numShippingLabels =
//               ordersByPieceTypeBuilder[currentShipment.pieceType]
//                 .numShippingLabels +
//               parseInt(currentShipment.numShippingLabels);
//           }
//           return ordersByPieceTypeBuilder;
//         }, ordersByPieceType)
//       : ordersByPieceType;

//   console.log("ordersByPieceType: ", ordersByPieceType);

//   return (
//     <Modal show={show} onHide={onHide} size="xl" backdrop="static">
//       <Modal.Header>
//         <Modal.Title>Merging Orders</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <div className="row">
//           <div className="col-12"></div>
//           <div className="col-6">
//             <div className="font-600">
//               {ordersToMerge?.[0]?.dataToSubmit?.customerName}
//               <br />
//               {ordersToMerge?.[0]?.dataToSubmit?.customerAddress.address
//                 ? ordersToMerge?.[0]?.dataToSubmit?.customerAddress.address +
//                   " | "
//                 : ""}
//               {assembleCityStateZipWithNotFound(
//                 ordersToMerge?.[0]?.dataToSubmit?.customerAddress.city,
//                 ordersToMerge?.[0]?.dataToSubmit?.customerAddress.state,
//                 ordersToMerge?.[0]?.dataToSubmit?.customerAddress.zip
//               )}
//             </div>
//             <div>
//               <div className="text-note font-600">
//                 Combined Comment <BsPencilSquare />
//               </div>
//               {ordersToMerge?.reduce((rolling, currentOrder) => {
//                 return currentOrder?.dataToSubmit?.comments
//                   ? rolling + currentOrder?.dataToSubmit?.comments + "|"
//                   : rolling;
//               }, "")}
//             </div>
//           </div>
//           <div className="col-6">
//             <DiliTextCP
//               name="combinedTimeCode"
//               type="select"
//               label="Time Code"
//               labelClass="mb-0"
//               required
//               onChange={handleChangeTimeCode}
//             >
//               <option value="">Select Time Code</option>
//               {ordersToMerge?.[0]?.dataToSubmit?.timeCodes.map((timeCode) => {
//                 return <option key={timeCode}>{timeCode}</option>;
//               })}
//             </DiliTextCP>
//           </div>
//         </div>
//         <div className="d-flex justify-content-center mt-2 h4">
//           <div
//             onClick={() => {
//               handleSelectMergeViewType(mergeOrderViewTypes.byInvoice);
//             }}
//             className={`p-3 no-copy clickable ${
//               mergeViewType === mergeOrderViewTypes.byInvoice ? "" : "text-note"
//             }`}
//           >
//             By Invoice
//           </div>
//           <div
//             onClick={() => {
//               handleSelectMergeViewType(mergeOrderViewTypes.byPieceType);
//             }}
//             className={`p-3 no-copy clickable ${
//               mergeViewType === mergeOrderViewTypes.byPieceType
//                 ? ""
//                 : "text-note"
//             }`}
//           >
//             By Piece Type
//           </div>
//         </div>
//         <div className="row mb-2 d-flex justify-content-between">
//           <div className="col-3">
//             <DiliTextCP placeholder="Filter By Invoice" />
//             {/* <div className="btn-group">
//               <button className="btn btn-light">By Invoice</button>
//               <button className="btn btn-light">By Piece Type</button>
//             </div> */}
//           </div>
//         </div>
//         <div>
//           <div className="position-relative">
//             <div
//               className="panel-inset-overlay"
//               style={{ borderRadius: ".25rem" }}
//             ></div>
//             {mergeViewType === mergeOrderViewTypes.byInvoice && (
//               <div
//                 className="bg-inner-gray d-flex"
//                 style={{ borderRadius: ".25rem", maxHeight: "300px" }}
//               >
//                 {/* <div
//                 className="d-flex flex-column border-right"
//                 style={{ backgroundColor: "white" }}
//               >
//                 {ordersToMerge.map((orderToMerge, index) => {
//                   // console.log(orderToMerge);
//                   return (
//                     <div
//                       className={`${
//                         index >= ordersToMerge.length - 1 ? "" : "border-bottom"
//                       } p-3 py-2`}
//                     >
//                       {orderToMerge?.dataToSubmit?.invoiceNumber}
//                     </div>
//                   );
//                 })}
//               </div> */}
//                 <div className="px-4 p-2 row flex-fill">
//                   {ordersToMerge.map((orderToMerge, index) => {
//                     return (
//                       <div key={orderToMerge.CDKOrderID} className="col-3 p-2">
//                         <div className="panel-flat bg-main">
//                           <div className="border-bottom pl-2 pt-2 pb-1">
//                             {orderToMerge.dataToSubmit.invoiceNumber}
//                           </div>
//                           <div className="p-2 font-semi-small">
//                             {orderToMerge.dataToSubmit.shipments.map(
//                               (shipment) => {
//                                 return (
//                                   <div
//                                     key={shipment.pieceType}
//                                     className="d-flex"
//                                   >
//                                     <div>
//                                       {shipment.numShippingLabels +
//                                         " " +
//                                         newPieceTypes[
//                                           newPieceTypesValueMap[
//                                             shipment.pieceType
//                                           ]
//                                         ].display +
//                                         (shipment.numShippingLabels > 1 &&
//                                         !newPieceTypes[
//                                           newPieceTypesValueMap[
//                                             shipment.pieceType
//                                           ]
//                                         ].staysSingular
//                                           ? "s"
//                                           : "")}
//                                     </div>
//                                   </div>
//                                 );
//                               }
//                             )}
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               </div>
//             )}
//             {mergeViewType === mergeOrderViewTypes.byPieceType && (
//               <div className="bg-inner-gray d-flex">
//                 {Object.entries(ordersByPieceType).map(
//                   ([pieceType, order], index) => {
//                     return (
//                       <div
//                         className={`d-flex flex-column flex-fill bg-main text-center ${
//                           index < Object.entries(ordersByPieceType).length - 1
//                             ? "border-right"
//                             : ""
//                         }`}
//                       >
//                         <div className="p-3 border-bottom text-note font-600">
//                           {newPieceTypesValueMap[pieceType]}
//                         </div>
//                         <div className="p-3">
//                           {order.invoiceNumbers.map((invoiceNumber, index) => {
//                             return (
//                               <div key={index + "-" + invoiceNumber}>
//                                 {invoiceNumber}
//                               </div>
//                             );
//                           })}
//                         </div>
//                       </div>
//                     );
//                   }
//                 )}
//               </div>
//             )}
//           </div>
//           <div className="mt-3">
//             <div>
//               <h5>Merged Orders</h5>
//             </div>
//             <table className="table">
//               <thead>
//                 <tr>
//                   <th>Order</th>
//                   <th>Shipments</th>
//                   <th>Invoices</th>
//                   <th>Insurance</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {Object.entries(ordersByPieceType).map(
//                   ([pieceType, mergedOrderData], index) => {
//                     return (
//                       mergedOrderData.numShippingLabels > 0 && (
//                         <tr key={mergedOrderData.CDKOrderID}>
//                           <td>{index + 1}</td>
//                           <td>
//                             {displayPieceType(
//                               mergedOrderData.numShippingLabels,
//                               pieceType
//                             )}
//                           </td>
//                           <td style={{ maxHeight: "150px", overflowY: "auto" }}>
//                             <Chips
//                               items={mergedOrderData.invoiceNumbers}
//                               // amountToShow={1}
//                             />
//                             {/* {mergedOrderData.invoiceNumbers.slice(0,2).map(
//                               (invoiceNumber, index) => {
//                                 return (
//                                   <div className="order-history-invoice-chip">
//                                     {invoiceNumber}
//                                   </div>
//                                 );
//                               }
//                             )}
//                             {mergedOrderData.invoiceNumbers.length > 2 &&
//                             <div className="order-history-invoice-chip">+ {mergedOrderData.invoiceNumbers.length - 5} </div>
//                   } */}
//                           </td>
//                           <td>{"todo"}</td>
//                         </tr>
//                       )
//                     );
//                   }
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </Modal.Body>
//       <Modal.Footer>
//         <button type="button" className="btn btn-secondary" onClick={onHide}>
//           Cancel
//         </button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// const HiddenOrdersRestorationModal = ({
//   show,
//   onHide,
//   hiddenOrders,
//   handleUnhide,
// }) => {
//   return (
//     <Modal show={show} onHide={onHide}>
//       <Modal.Header>
//         <Modal.Title>Hidden Orders</Modal.Title>
//       </Modal.Header>
//       <Modal.Body style={{ padding: 0, maxHeight: "75dvh", overflow: "auto" }}>
//         {hiddenOrders.length > 0 ? (
//           hiddenOrders.map((order) => {
//             return (
//               <div
//                 className="cdk-multifinal-modal-invoice-container"
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   padding: "1rem",
//                 }}
//               >
//                 {order.dataToSubmit.invoiceNumber}
//                 <button
//                   className="btn btn-primary"
//                   onClick={() => {
//                     handleUnhide(order.CDKOrderID);
//                   }}
//                 >
//                   Restore
//                 </button>
//               </div>
//             );
//           })
//         ) : (
//           <div style={{ textAlign: "center", padding: "2rem" }}>
//             No hidden orders
//           </div>
//         )}
//       </Modal.Body>
//       <Modal.Footer>
//         <button type="button" onClick={onHide} className="btn btn-secondary">
//           Close
//         </button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

const TimeCode = ({
  city,
  state,
  zip,
  cdkOrder,
  handleUpdateTimeCode,
  handleUpdateTimeCodes,
  // handleUpdateDidInitialTimeCodeFetch,
}) => {
  const history = useHistory();
  // const [timeCodes, setTimeCodes] = useState([]);
  const [loadingTimeCodes, setLoadingTimeCodes] = useState(false);

  // const [previousCity, setPreviousCity] = useState(city);
  // const [previousState, setPreviousState] = useState(state);

  useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      try {
        // console.log(cdkOrder.dataToSubmit.didInitialTimeCodeFetch);
        if (!cdkOrder.dataToSubmit.didInitialTimeCodeFetch) {
          setLoadingTimeCodes(true);
          const response = await getTimeCodesForCityAndStateAndZip(
            city,
            state,
            zip
          );
          // console.log(response.data);
          // console.log(response.data);
          // setTimeCodes(response.data);
          handleUpdateTimeCodes(
            cdkOrder.CDKOrderID,
            cdkOrder.isMergedOrder,
            response.data
          );
        }
      } catch (ex) {
        handleApiError(ex, history);
        //*****= Need to replace below with fetch error state so we can differentiate between no time codes for city/state vs other errors **********/
        handleUpdateTimeCodes(cdkOrder.CDKOrderID, cdkOrder.isMergedOrder, []);
      } finally {
        if (isMounted) {
          setLoadingTimeCodes(false);
        }
      }
    };
    fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  const handleOnChange = (e) => {
    // console.log(e.target.value);
    handleUpdateTimeCode(cdkOrder.CDKOrderID, e.target.value);
  };
  return (
    <DiliTextCP
      required
      type="select"
      // label="Time Codes"
      name="timeCode"
      value={cdkOrder.dataToSubmit.timeCode}
      onChange={handleOnChange}
      // loading={loadingTimeCodes}
      disabled={loadingTimeCodes}
      wasSubmitted={cdkOrder.wasSubmitted}
      // showProblemText={cdkOrder.dataToSubmit.timeCodes.length === 0}
      invalidText={
        cdkOrder.dataToSubmit.timeCodes.length === 0
          ? "No time codes found for city/state. Please select a city available or contact Diligent Support ."
          : cdkOrder.dataToSubmit.timeCode === ""
          ? "Please select a time code."
          : ""
      }
      inputClass="text-ellipsis"
      helperTextClass="font-extra-small text-note"
      helperText={"Multiple options available"}
      showHelperText={cdkOrder.dataToSubmit.timeCodes.length > 1}
      // onChange={handleChangeForm}
      // value={selectedTimeCode}
      // className="col-6 form-group"
      // loading={fetchingCitiesForState}
      // showProblemText={citiesForState.length <= 0}
      // problemText={
      // fetchingCitiesForState
      // ? "Loading cities"
      // : "No cities found for this state."
      // }
    >
      <option value="">
        {loadingTimeCodes ? "Loading..." : "Select a Time Code"}
      </option>
      {cdkOrder.dataToSubmit.timeCodes.map((timeCode, index) => {
        return <option key={index + "-" + timeCode}>{timeCode}</option>;
      })}
    </DiliTextCP>
  );
};

const EditCommentsModal = ({
  show,
  onHide,
  comments,
  cdkOrder,
  shipmentIndex,
  finishUpdatingCommentsForOrder,
}) => {
  const [currentComments, setCurrentComments] = useState(comments ?? "");
  // console.log("editing comments modal", currentComments);

  useEffect(() => {
    setCurrentComments(comments ?? "");
  }, [comments]);

  const handleChangeComments = (e) => {
    setCurrentComments(e.target.value);
  };

  const submitChanges = () => {
    finishUpdatingCommentsForOrder(cdkOrder, shipmentIndex, currentComments);
  };

  //for merged orders
  const [selectedMergedOrderInvoice, setSelectedMergedOrderInvoice] = useState(
    cdkOrder?.dataToSubmit?.invoiceNumber
  );
  useEffect(() => {
    // console.log(cdkOrder);
    setSelectedMergedOrderInvoice(cdkOrder?.dataToSubmit?.invoiceNumber);
  }, [cdkOrder?.dataToSubmit.invoiceNumber]);

  // console.log(selectedMergedOrderInvoice);
  // console.log(cdkOrder);
  const handleSelectMergedOrderInvoice = (invoiceNumber) => {
    setSelectedMergedOrderInvoice(invoiceNumber);
  };

  const shipmentTypeCommentIsFor =
    cdkOrder?.dataToSubmit?.shipments?.[shipmentIndex]?.pieceType;

  // console.log("current shipment type: ", shipmentTypeCommentIsFor);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Editing Comments</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {cdkOrder?.isMergedOrder && (
          <div className="text-note font-600">Merged Comments</div>
        )}
        <DiliTextCP
          type="textarea"
          rows={4}
          maxLength={commentLimit}
          displayTextAreaCharacterCountNotCol
          value={currentComments}
          onChange={handleChangeComments}
        />
        {cdkOrder?.isMergedOrder && (
          <div className="mt-2">
            <div className="text-note font-600">Invoices</div>
            <div>
              {cdkOrder?.originalRows.map((row) => {
                return (
                  <div
                    className={`order-history-invoice-chip ${
                      selectedMergedOrderInvoice ===
                      row.dataToSubmit.invoiceNumber
                        ? "chip-selected"
                        : ""
                    }`}
                    role="button"
                    onClick={() => {
                      handleSelectMergedOrderInvoice(
                        row.dataToSubmit.invoiceNumber
                      );
                    }}
                    key={row.dataToSubmit.invoiceNumber}
                  >
                    {row.dataToSubmit.invoiceNumber}
                  </div>
                );
              })}
            </div>
            <div
              className="position-relative bg-inner-gray"
              style={{ height: "6rem" }}
            >
              <div
                className="panel-inset-overlay"
                style={{ borderRadius: ".25rem" }}
              ></div>
              <div
                className="px-3 pb-2 pt-1 my-2 custom-scrollbar"
                style={{ height: "100%", overflow: "auto" }}
              >
                {cdkOrder.originalRows
                  .find((row) => {
                    return (
                      row.dataToSubmit.invoiceNumber ===
                      selectedMergedOrderInvoice
                    );
                  })
                  ?.dataToSubmit?.shipments?.find((shipment) => {
                    // console.log("finding matching shipment");
                    // console.log(shipment);
                    // console.log(shipment.pieceType);
                    // console.log(shipmentTypeCommentIsFor);
                    return shipment.pieceType === shipmentTypeCommentIsFor;
                  })?.comments || (
                  <div
                    className="text-note font-600 font-semi-small"
                    style={{
                      display: "grid",
                      placeContent: "center",
                      height: "100%",
                    }}
                  >
                    No Comments
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onHide}>
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={submitChanges}
        >
          Update
        </button>
      </Modal.Footer>
    </Modal>
  );
};

const alternativeSortingOptions = {
  closedDate: {
    columnAccessor: "originalCDKData.closedDate",
    display: "Closed Date",
  },
  openDate: {
    columnAccessor: "originalCDKData.openDate",
    display: "Open Date",
    //type:"dateString"
  },
  postedDate: {
    columnAccessor: "originalCDKData.postedDate",
    display: "Posted Date",
  },
  shipDate: {
    columnAccessor: "originalCDKData.shipDate",
    display: "CDK Ship Date",
  },
};
const alternativeSortingOptionsArray = Object.entries(
  alternativeSortingOptions
);
// console.log(alternativeSortingOptionsArray);
// const alternativeSortingOptions = [
//   { columnAccessor: "originalCDKData.openDate", display: "Open Date" },
//   { columnAccessor: "originalCDKData.closedDate", display: "Closed Date" },
//   { columnAccessor: "originalCDKData.postedDate", display: "Posted Date" },
//   { columnAccessor: "originalCDKData.shipDate", display: "CDK Ship Date" },
// ];
const rowEqualityCheck = (oldRow, newRow) => {
  return (
    oldRow.CDKOrderID === newRow.CDKOrderID &&
    oldRow.isMergedOrder === newRow.isMergedOrder
  );
};
export const CDKOrderImportTable = ({
  cdkOrderTableData,
  setCDKOrderTableData,
  viewState,
  setLoading,
}) => {
  // console.log(cdkOrderTableData);
  //merged rows
  // const [mergedRows, setMergedRows] = useState([]);
  // console.log(mergedRows);
  //the ids of the rows that are currently merged
  const [mergedRowIds, setMergedRowIds] = useState([]);

  const history = useHistory();
  const [jwtInfo, setJWTInfo] = useState(null);
  useEffect(() => {
    try {
      setJWTInfo(jwtDecode(localStorage.getItem(tokenKeyName)));
    } catch (ex) {
      toast.error("Error parsing client info.");
    }
  }, []);

  //Helpers
  // const assembleCityStateZip = (city, state, zip) => {
  //   let cityStateZip = "";
  //   cityStateZip += city; //city will be added, whether it is blank or not.
  //   if (city && state) {
  //     //if both city and state are not blank, add a comma and space
  //     cityStateZip += ", ";
  //   }
  //   cityStateZip += state ? state + " " : ""; //add state, if it is not blank, add a space after.
  //   cityStateZip += zip;
  //   return cityStateZip;
  // };

  //TABLE PROCESSING=====================================================================
  const [showHiddenOrders, setShowHiddenOrders] = useState(false);
  const handleToggleShowHiddenOrders = () => {
    setShowHiddenOrders((prev) => !prev);
    //reset selections
    setCDKOrderTableData((oldData) => {
      return oldData.map((oldRow) => {
        return { ...oldRow, isSelected: false };
      });
    });
  };

  //hidden because it's been imported
  const cdkOrderTableDataNonImported = cdkOrderTableData.filter((row) => {
    return !row.isImported;
  });
  //hidden by user
  // const nonHiddenTableData = cdkOrderTableDataNonImported.filter((row) => {
  //   return !row.isHidden;
  // });
  let nonHiddenTableData = [];
  let hiddenTableData = [];
  for (let i = 0; i < cdkOrderTableDataNonImported.length; i++) {
    if (cdkOrderTableDataNonImported[i].isHidden) {
      hiddenTableData.push(cdkOrderTableDataNonImported[i]);
    } else {
      nonHiddenTableData.push(cdkOrderTableDataNonImported[i]);
    }
  }

  //helper arrays
  const selectedRows = showHiddenOrders
    ? hiddenTableData.filter((row) => row.isSelected)
    : nonHiddenTableData.filter((row) => row.isSelected);

  // console.log(
  //   "selected rows",
  //   selectedRows.map((row) => row.dataToSubmit.invoiceNumber)
  // );

  // const selectedMergedRows = mergedRows.filter((row) => row.isSelected);
  //end helper maps

  //filters
  const [filters, setFilters] = useState({
    CDKOrderID: "",
    invoiceNumber: "",
    customer: "",
    comments: "",
  });

  const handleChangeFilter = (e) => {
    setFilters((oldFilters) => {
      return {
        ...oldFilters,
        [e.target.name]: e.target.value,
      };
    });
  };

  // console.log(filters.customer);
  //if the show hidden toggle is on, we want to base the rest of the processing on the hiddenTableData array(to show them the hidden orders instead)
  const filteredTableData = showHiddenOrders
    ? hiddenTableData.filter((row) => {
        // console.log(
        //   `${row.dataToSubmit.customerName} ${row.dataToSubmit.customerAddress.address} ${row.dataToSubmit.customerAddress.cityStateZip}`
        // );
        return (
          row.dataToSubmit.invoiceNumber
            .toLowerCase()
            .includes(filters.invoiceNumber.trim().toLowerCase()) &&
          `${row.dataToSubmit.customerName} ${row.dataToSubmit.customerAddress.address} ${row.dataToSubmit.customerAddress.city}, ${row.dataToSubmit.customerAddress.state} ${row.dataToSubmit.customerAddress.zip}`
            .toLowerCase()
            .includes(filters.customer.trim().toLowerCase()) &&
          ("" + row.CDKOrderID).includes(filters.CDKOrderID.trim()) &&
          row.dataToSubmit.comments
            .toLowerCase()
            .includes(filters.comments.trim().toLowerCase()) &&
          !(mergedRowIds.includes(row.CDKOrderID) && !row.isMergedOrder)
        );
      })
    : nonHiddenTableData.filter((row) => {
        // console.log(
        //   `${row.dataToSubmit.customerName} ${row.dataToSubmit.customerAddress.address} ${row.dataToSubmit.customerAddress.cityStateZip}`
        // );
        return (
          row.dataToSubmit.invoiceNumber
            .toLowerCase()
            .includes(filters.invoiceNumber.trim().toLowerCase()) &&
          `${row.dataToSubmit.customerName} ${row.dataToSubmit.customerAddress.address} ${row.dataToSubmit.customerAddress.city}, ${row.dataToSubmit.customerAddress.state} ${row.dataToSubmit.customerAddress.zip}`
            .toLowerCase()
            .includes(filters.customer.trim().toLowerCase()) &&
          ("" + row.CDKOrderID).includes(filters.CDKOrderID.trim()) &&
          row.dataToSubmit.comments
            .toLowerCase()
            .includes(filters.comments.trim().toLowerCase()) &&
          !(mergedRowIds.includes(row.CDKOrderID) && !row.isMergedOrder)
        );
      });

  //sorting
  const sortByStates = {
    none: "none",
    asc: "asc",
    desc: "desc",
  };
  // const [sortByNumParts, setSortByNumParts] = useState(sortByStates.none);
  // const [sortByID, setSortByID] = useState(sortByStates.desc);
  // const handleChangeSortByNumParts = (e) => {
  //   setSortByNumParts((prev) => {
  //     if (prev === sortByStates.none) {
  //       return sortByStates.asc;
  //     } else if (prev === sortByStates.asc) {
  //       return sortByStates.desc;
  //     } else if (prev === sortByStates.desc) {
  //       return sortByStates.none;
  //     }
  //   });
  // };

  const cycleSortState = (prevState) => {
    if (prevState === sortByStates.none) {
      return sortByStates.asc;
    } else if (prevState === sortByStates.asc) {
      return sortByStates.desc;
    } else if (prevState === sortByStates.desc) {
      return sortByStates.none;
    }
  };

  const [sortByColumn, setSortByColumn] = useState({
    column: alternativeSortingOptions.closedDate.columnAccessor,
    state: sortByStates.desc,
  });

  const handleChangeSortColumn = (accessor) => {
    // console.log(accessor);
    setSortByColumn((prev) => {
      return {
        column: accessor,
        state:
          prev.column === accessor //if the same column was clicked, cycle through the sort states as normal, if another column was clicked, start at "none" state.
            ? cycleSortState(prev.state)
            : cycleSortState(sortByStates.none), //right now it always goes from none to asc but instead of hardcoding it, just using this function in case we want to change the logic later
      };
    });
  };
  const handleChangeAltSortColumn = (e) => {
    // console.log(accessor);
    setSortByColumn((prev) => {
      return {
        column: e.target.value,
        state:
          prev.state === sortByStates.none //for the select menu, when we switch the sort column, keep the sort order the same as previous unless it was none,
            ? cycleSortState(sortByStates.none) // in which case call our cycle method and pass in none instead of hard coding it. This is so if we decide to change the order of how the sort cycles it will change everywhere
            : prev.state,
      };
    });
  };
  // console.log(sortByColumn);
  const handleClickSortOrderButton = (e) => {
    setSortByColumn((prev) => ({ ...prev, state: cycleSortState(prev.state) }));
  };

  //sorting was not working with the retun a-b shortcut
  //the shortcut does not work for strings so we have to do the normal method of comparing them
  // console.log("5t" - "3t"); //returns NaN
  // console.log("5t" > "3t"); //returns true
  // console.log("3t" > "5t"); //returns false
  // console.log("2023-08-21T000000:00" > "2023-08-20T000000:00") //returns true, attempting to subtract instead returns NaN

  const sortedTableData = filteredTableData.sort((a, b) => {
    // console.log(get(a, sortByColumn.column));
    // console.log(get(a, sortByColumn.column) - get(b, sortByColumn.column));
    // console.log(get(b, sortByColumn.column));
    //move merged orders to the beginning, but keep them in the order they were merged
    if (a.isMergedOrder && b.isMergedOrder) {
      return 0;
    } else if (a.isMergedOrder) {
      return -1;
    } else if (b.isMergedOrder) {
      return 1;
    }
    if (sortByColumn.state === sortByStates.none) {
      return 0;
    }
    const aProperty = get(a, sortByColumn.column);
    const bProperty = get(b, sortByColumn.column);
    if (sortByColumn.state === sortByStates.asc) {
      // console.log("a-b");
      if (aProperty > bProperty) {
        return 1;
      } else if (bProperty > aProperty) {
        return -1;
      } else {
        return 0;
      }
      // return get(a, sortByColumn.column) - get(b, sortByColumn.column); //does not work for strings
    } else if (sortByColumn.state === sortByStates.desc) {
      // console.log("b-a");
      if (aProperty > bProperty) {
        return -1;
      } else if (bProperty > aProperty) {
        return 1;
      } else {
        return 0;
      }
      // return get(b, sortByColumn.column) - get(a, sortByColumn.column); //does not work for strings
    }
  });

  // sortedTableData.map((order) => {
  //   console.log(get(order, sortByColumn.column));
  // });

  // console.log(sortByColumn);

  // let sortingTest = filteredTableData;
  // const sortByFields = ["CDKOrderID", "dataToSubmit.CDKNumParts"];
  // let sortByFields = [];
  // for (let i = 0; i < sortByFields.length; i++) {
  // const currentSortByField = sortByFields[i];
  // sortingTest = sortingTest.sort((a, b) => {
  // console.log(get(a, currentSortByField));
  // return get(a, currentSortByField) - get(b, currentSortByField);
  // });
  // }

  // const sortedTableData = filteredTableData.sort((a, b) => {
  // return 0;
  // if (sortByNumParts === sortByStates.none) {
  //   return 0;
  // } else if (sortByNumParts === sortByStates.asc) {
  //   return a.dataToSubmit.CDKNumParts - b.dataToSubmit.CDKNumParts;
  // } else if (sortByNumParts === sortByStates.desc) {
  //   return b.dataToSubmit.CDKNumParts - a.dataToSubmit.CDKNumParts;
  // }

  // console.log(a);
  // if(sortByID === sortByStates.none && sortByNumParts === )
  // return (
  //   // a.dataToSubmit.CDKNumParts - b.dataToSubmit.CDKNumParts ||
  //   b.CDKOrderID - a.CDKOrderID
  //   // a.dataToSubmit.CDKNumParts - b.dataToSubmit.CDKNumParts
  // );
  // });

  //end sorting

  //pagination
  //Pagination
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const totalPages = Math.max(1, Math.ceil(sortedTableData.length / pageSize));
  const [pageSearchValue, setPageSearchValue] = useState(1);

  //in case we remove/import orders on the last page for example 2/2, we would end up on page 2/1.
  //so if that ever happens lets set the page number to totalPages
  useEffect(() => {
    if (page > totalPages) {
      setPage(totalPages);
      setPageSearchValue(totalPages);
    }
  }, [totalPages]);

  let pageOptions = [];
  for (let i = 0; i < totalPages; i++) {
    pageOptions.push(i);
  }
  //slice will do a shallow copy ***** probably not a problem as we will not be modifying the orders on this page.
  const tableDataToDisplay = sortedTableData.slice(
    (page - 1) * pageSize,
    page * pageSize
  );

  const goToPage = (pageToGo) => {
    // console.log("go to page?");
    // console.log(pageToGo);
    // console.log(page);
    // console.log(totalPages);
    if (pageToGo >= 1 && pageToGo <= totalPages) {
      setPage(pageToGo);
      setPageSearchValue(pageToGo);
      // console.log("NAVIGATED");
    }
  };

  const handleChangePageSize = (e) => {
    //update current page as they change page size, or else it'll feel weird. Alternatively, we can set it back to page 1, every time page size changes.
    // console.log("page size, page update");
    // console.log("Previous page size: " + pageSize);
    // console.log("New page size: " + e.target.value);
    // console.log("previous page: " + page);
    // const newPage = Math.ceil((pageSize / e.target.value) * page); //tried coming up with a formula but it didn't quite work

    // so found one on stackoverflow:
    // https://stackoverflow.com/a/73485773/12156650
    const indexOfFirstItemOnPage = pageSize * (page - 1) + 1;
    // console.log("Index of first item on page was: " + indexOfFirstItemOnPage);
    const newPage = Math.ceil(indexOfFirstItemOnPage / e.target.value);
    // console.log("New Page: " + newPage);

    setPage(newPage);
    setPageSearchValue(newPage);
    setPageSize(e.target.value);
  };
  //page search
  const handlePageSearchChange = (e) => {
    //if a non-number is entered, return;
    if (e.target.value === "") {
      goToPage(1);
      setPageSearchValue("");
      return;
    }
    if (parseInt(e.target.value) === NaN) {
      return;
    }

    const pageToGo = parseInt(e.target.value);
    if (pageToGo > totalPages) {
      goToPage(totalPages);
      setPageSearchValue(totalPages);
      return;
    }

    //we already check to see if the number is within the amount of pages we have in this function so no need to check again here.
    goToPage(pageToGo);
    setPageSearchValue(pageToGo);
  };

  //End Pagination

  //END TABLE PROCESSING========================/

  // console.log(tableDataToDisplay);
  const handleSelectPage = (e) => {
    // console.log(e.target.checked);
    // const orderIDsOnPage = tableDataToDisplay.map((row) => {
    //   return row.CDKOrderID;
    // });
    //tableDataToDisplay contains the orders on the page
    setCDKOrderTableData((oldData) => {
      return oldData.map((oldRow, index) => {
        // if (orderIDsOnPage.includes(oldRow.CDKOrderID)) {
        if (
          tableDataToDisplay.find((rowOnPage) => {
            return rowEqualityCheck(oldRow, rowOnPage);
          })
        ) {
          // console.log(oldRow.CDKOrderID);
          return {
            ...oldRow,
            isSelected: e.target.checked,
          };
        } else {
          return oldRow;
        }
      });
    });
  };

  const handleSelectRow = useCallback(
    (e, row) => {
      // console.log(rowData.CDKOrderID);
      // const setOrderData = row.isMergedOrder
      //   ? setMergedRows
      //   : setCDKOrderTableData;
      setCDKOrderTableData((oldData) => {
        return oldData.map((oldRow, index) => {
          if (rowEqualityCheck(oldRow, row)) {
            return {
              ...oldRow,
              isSelected: !oldRow.isSelected,
            };
          } else {
            return oldRow;
          }
        });
      });
    },
    [setCDKOrderTableData]
  );
  const handleDeselectAllRows = useCallback(() => {
    setCDKOrderTableData((oldData) => {
      return oldData.map((oldRow) => {
        if (oldRow.isSelected) {
          return {
            ...oldRow,
            isSelected: !oldRow.isSelected,
          };
        } else {
          return oldRow;
        }
      });
    });
  }, [setCDKOrderTableData]);

  const [cdkOrderToHide, setCDKOrderToHide] = useState();
  const [showHideCDKOrderConfirmModal, setShowHideCDKOrderConfirmModal] =
    useState(false);
  const handleClickHideCDKRowButton = useCallback(
    (e, row) => {
      setCDKOrderToHide(row);
      setShowHideCDKOrderConfirmModal(true);
    },
    [setCDKOrderTableData]
  );
  const handleCancelHideCDKRow = () => {
    setShowHideCDKOrderConfirmModal(false);
  };
  // console.log(showHideCDKOrderConfirmModal);

  const handleHideCDKRow = useCallback(
    async (row) => {
      try {
        setLoading(true);
        await changeCDKOrdersHiddenStatus([row.CDKOrderID], true);
      } catch (ex) {
        handleApiError(
          ex,
          history,
          false,
          `There was an issue removing invoice ${row.dataToSubmit.invoiceNumber}. Please try again.`
        );
        return;
      } finally {
        setLoading(false);
      }
      setCDKOrderTableData((oldData) => {
        return oldData.map((oldRow, index) => {
          //hiding is not available for merged orders so we just need to check if the order ids match but using the rowEqualityCheck function to keep things consistent and possibly future-proofing
          if (rowEqualityCheck(oldRow, row)) {
            return { ...oldRow, isHidden: true, isSelected: false };
          } else {
            return oldRow;
          }
        });
      });
      setShowHideCDKOrderConfirmModal(false);
    },
    [setCDKOrderTableData, setLoading]
  );
  const handleHideSelectedCDKRows = useCallback(
    async (rowsToHide) => {
      // console.log(orderIDs);
      const rowsToHideIds = rowsToHide.map((row) => {
        return row.CDKOrderID;
      });
      try {
        setLoading(true);
        await changeCDKOrdersHiddenStatus(rowsToHideIds, true);
      } catch (ex) {
        handleApiError(
          ex,
          history,
          false,
          `There was an issue removing the selected orders. Please try again.`
        );
        return;
      } finally {
        setLoading(false);
      }
      setCDKOrderTableData((oldData) => {
        return oldData.map((oldRow, index) => {
          // if (rowsToHide.includes(oldRow.CDKOrderID)) {
          if (
            rowsToHide.find((rowToHide) => {
              return rowEqualityCheck(oldRow, rowToHide);
            })
          ) {
            return { ...oldRow, isHidden: true, isSelected: false };
          } else {
            return oldRow;
          }
        });
      });
      setShowHideCDKOrderConfirmModal(false);
    },
    [setCDKOrderTableData, setLoading]
  );
  const handleUnhideCDKOrder = useCallback(
    async (row) => {
      try {
        setLoading(true);
        await changeCDKOrdersHiddenStatus([row.CDKOrderID], false);
      } catch (ex) {
        handleApiError(
          ex,
          history,
          false,
          `There was an issue unhiding invoice ${row.dataToSubmit.invoiceNumber}. Please try again.`
        );
        return;
      } finally {
        setLoading(false);
      }
      setCDKOrderTableData((oldData) => {
        //unhiding also does not pertain to merged orders, but using the rowEqualityCheck function again to be consistent
        return oldData.map((oldRow, index) => {
          if (rowEqualityCheck(oldRow, row)) {
            return { ...oldRow, isHidden: false, isSelected: false };
          } else {
            return oldRow;
          }
        });
      });
    },
    [setCDKOrderTableData, setLoading]
  );
  const handleUnhideSelectedCDKRows = useCallback(
    async (rowsToUnhide) => {
      const rowsToUnhideIds = rowsToUnhide.map((row) => {
        return row.CDKOrderID;
      });
      try {
        setLoading(true);
        await changeCDKOrdersHiddenStatus(rowsToUnhideIds, false);
      } catch (ex) {
        handleApiError(
          ex,
          history,
          false,
          `There was an issue unhiding the selected orders. Please try again.`
        );
        return;
      } finally {
        setLoading(false);
      }
      setCDKOrderTableData((oldData) => {
        return oldData.map((oldRow, index) => {
          // if (orderIDs.includes(oldRow.CDKOrderID)) {
          if (
            rowsToUnhide.find((rowToUnhide) => {
              return rowEqualityCheck(oldRow, rowToUnhide);
            })
          ) {
            return { ...oldRow, isHidden: false, isSelected: false };
          } else {
            return oldRow;
          }
        });
      });
    },
    [setCDKOrderTableData, setLoading]
  );

  const handleExpandRow = useCallback(
    (e, row) => {
      // console.log(rowData.CDKOrderID);
      // const setOrderData = row.isMergedOrder
      //   ? setMergedRows
      //   : setCDKOrderTableData;
      setCDKOrderTableData((oldData) => {
        return oldData.map((oldRow, index) => {
          if (rowEqualityCheck(oldRow, row)) {
            return {
              ...oldRow,
              isExpanded: !oldRow.isExpanded,
            };
          } else {
            return oldRow;
          }
        });
      });
    },
    [setCDKOrderTableData]
  );

  //Editing Modals
  //Customer===================================================================================
  //"Customer" is a combination of customer name and address.
  const [isEditCustomerModalOpen, setIsEditCustomerModalOpen] = useState(false);
  const [cdkOrderToEdit, setCDKOrderToEdit] = useState();

  const openEditCustomerModal = (row) => {
    setIsEditCustomerModalOpen(true);
    setCDKOrderToEdit(row);
  };
  const closeEditCustomerModal = () => {
    setIsEditCustomerModalOpen(false);
    // setCDKOrderToEdit(null);
  };
  const finishUpdatingCustomerForOrder = (
    cdkOrderID,
    isMergedOrder,
    newCustomerDetailsObject
  ) => {
    // if (
    //   oldRow.dataToSubmit.customerAddress.city !==
    //   newCustomerDetailsObject.city
    // ) {
    //   // console.log("need to fetch time codes for this row");

    //   try {
    //     const timeCodesResponse = await getTimeCodesForCityAndState(
    //       newCustomerDetailsObject.city,
    //       newCustomerDetailsObject.state
    //     );
    //     const timeCodes = timeCodesResponse.data;
    //     console.log(timeCodes);
    //     // console.log(timeCodesResponse);
    //   } catch (ex) {
    //     handleApiError(ex, history);
    //   }
    // }
    // const setOrderData = isMergedOrder ? setMergedRows : setCDKOrderTableData;
    setCDKOrderTableData((oldData) => {
      return oldData.map((oldRow, index) => {
        if (
          rowEqualityCheck(oldRow, {
            CDKOrderID: cdkOrderID,
            isMergedOrder: isMergedOrder,
          })
        ) {
          return {
            ...oldRow,
            dataToSubmit: {
              ...oldRow.dataToSubmit,
              customerName: newCustomerDetailsObject.customerName,
              customerAddress: {
                address: newCustomerDetailsObject.address,
                city: newCustomerDetailsObject.city,
                state: newCustomerDetailsObject.state,
                zip: newCustomerDetailsObject.zip,
              },
            },
          };
        } else {
          return oldRow;
        }
      });
    });

    setIsEditCustomerModalOpen(false);
    // setCDKOrderToEdit(null);
  };

  //Comments==================================================================================
  const [orderBeingEdited, setOrderBeingEdited] = useState();
  const [
    shipmentIndexOfCommentBeingEdited,
    setShipmentIndexOfCommentBeingEdited,
  ] = useState();

  const [isEditCommentsModalOpen, setIsEditCommentsModalOpen] = useState(false);
  const [commentToEdit, setCommentToEdit] = useState();
  const openEditCommentsModal = (row, shipmentIndex) => {
    setIsEditCommentsModalOpen(true);
    setOrderBeingEdited(row);
    setShipmentIndexOfCommentBeingEdited(shipmentIndex);
    setCommentToEdit(row.dataToSubmit.shipments[shipmentIndex].comments);
  };
  const closeCommentsEditModal = () => {
    setIsEditCommentsModalOpen(false);
    // setCommentToEdit(null);
  };

  const finishUpdatingCommentsForOrder = useCallback(
    (cdkOrder, shipmentIndex, comments) => {
      // const setOrderData = cdkOrder.isMergedOrder
      //   ? setMergedRows
      //   : setCDKOrderTableData;

      const newShipment = {
        ...cdkOrder.dataToSubmit.shipments[shipmentIndex],
        comments,
      };

      setCDKOrderTableData((oldData) => {
        return oldData.map((oldRow, index) => {
          if (rowEqualityCheck(oldRow, cdkOrder)) {
            return {
              ...oldRow,
              dataToSubmit: {
                ...oldRow.dataToSubmit,
                shipments: generateUpdatedShipmentArrayAtIndex(
                  cdkOrder.dataToSubmit.shipments,
                  shipmentIndex,
                  newShipment
                ),
              },
            };
          } else {
            return oldRow;
          }
        });
      });

      setIsEditCommentsModalOpen(false);
      setCommentToEdit(null);
    },
    [setCDKOrderTableData]
  );
  // End Editing Modals
  //update TimeCode
  const updateTimeCode = (cdkOrderID, timeCode, isMerged) => {
    // console.log(cdkOrderID);
    // console.log(timeCode);
    // const setOrderData = isMerged ? setMergedRows : setCDKOrderTableData;
    setCDKOrderTableData((oldData) => {
      return oldData.map((oldRow, index) => {
        if (
          rowEqualityCheck(oldRow, {
            CDKOrderID: cdkOrderID,
            isMergedOrder: isMerged,
          })
        ) {
          return {
            ...oldRow,
            dataToSubmit: {
              ...oldRow.dataToSubmit,
              timeCode: timeCode,
            },
          };
        } else {
          return oldRow;
        }
      });
    });
  };

  //update Time Codes
  //this function is to retrieve timecodes upon changing city/state/zip and update the dropdown options
  const updateTimeCodes = (cdkOrderID, isMergedOrder, timeCodes) => {
    // console.log(cdkOrderID);
    // console.log(timeCodes);
    // const setOrderData = isMergedOrder ? setMergedRows : setCDKOrderTableData;
    setCDKOrderTableData((oldData) => {
      return oldData.map((oldRow, index) => {
        if (
          rowEqualityCheck(oldRow, {
            CDKOrderID: cdkOrderID,
            isMergedOrder: isMergedOrder,
          })
        ) {
          return {
            ...oldRow,
            dataToSubmit: {
              ...oldRow.dataToSubmit,
              timeCodes: timeCodes,
              //we must make sure the time code is actually reset to the first option available or blank (or maybe we don't want to reset it if the new list of time codes has the previously selected one available)
              // timeCode: "",
              timeCode: timeCodes[0] ?? "",
              didInitialTimeCodeFetch: true,
            },
          };
        } else {
          return oldRow;
        }
      });
    });
  };

  //end UpdateTimeCode

  // TODO: fix state of select all checkbox to be based off what is currently selected on the page and have an indeterminate state
  // let selectAllState = "";
  // const amountSelected = cdkOrderTableData.filter((row) => {
  //   // console.log(row.isSelected);
  //   return row.isSelected === true;
  // }).length;

  // console.log(amountSelected);

  const updateCDKOrderMainFields = useCallback(
    (cdkOrder, field, newValue) => {
      setCDKOrderTableData((oldData) => {
        return oldData.map((oldRow, index) => {
          if (rowEqualityCheck(oldRow, cdkOrder)) {
            return {
              ...oldRow,
              [field]: newValue,
            };
          } else {
            return oldRow;
          }
        });
      });
    },
    [setCDKOrderTableData]
  );
  const multiUpdateCDKOrderMainFields = useCallback(
    (cdkOrderArray, field, newValue) => {
      //might need to update this to work with merged orders, but for now since we are only updating the isImported field and that will hide the merged order and the original orders are already hidden due to being merged, it should be fine
      setCDKOrderTableData((oldData) => {
        return oldData.map((oldRow, index) => {
          // if(cdkOrderIdArray.includes(oldRow.CDKOrderID)){
          if (
            cdkOrderArray.find((rowToUpdate) => {
              return rowEqualityCheck(oldRow, rowToUpdate);
            })
          ) {
            return {
              ...oldRow,
              [field]: newValue,
            };
          } else {
            return oldRow;
          }
        });
      });
    },
    [setCDKOrderTableData]
  );

  const handleEditOrder = useCallback(
    (e, row) => {
      const finalValue =
        e.target.type === "checkbox" ? e.target.checked : e.target.value;
      // console.log(e.target.name);
      // console.log(e.target.value);
      // console.log(row);
      setCDKOrderTableData((oldData) => {
        return oldData.map((oldRow, index) => {
          if (rowEqualityCheck(oldRow, row)) {
            //if we get a match for row ID, update that row
            // console.log("matched ------------");
            // console.log(e.target.name);
            // console.log(e.target.value);
            return {
              ...oldRow,
              dataToSubmit: {
                ...oldRow.dataToSubmit,
                [e.target.name]: finalValue,
              },
            };
          } else {
            return oldRow; //otherwise return the row as it was.
          }
        });
      });
    },
    [setCDKOrderTableData]
  );

  // const hiya = [
  //   { hi: "yo", yo: "hi" },
  //   { hi: "yo", yo: "hi" },
  // ];

  // console.log(hiya);
  // const yo = [...hiya];
  // console.log(yo);

  const generateUpdatedShipmentArrayAtIndex = (
    array,
    shipmentIndex,
    newShipment
  ) => {
    // console.log(array);
    // console.log(index);
    // console.log("indexo passed in: " + index);
    let updatedArray = [...array];
    // console.log(updatedArray);
    updatedArray[shipmentIndex] = newShipment;
    // console.log(updatedArray);
    return updatedArray;
  };

  const handleAddShipment = useCallback(
    (e, row) => {
      const pieceTypesValues = Object.values(newPieceTypes).map(
        (newPieceType) => {
          return newPieceType.value;
        }
      );
      const pieceTypeToAdd = pieceTypesValues.find((pieceTypeValue) => {
        return !row.dataToSubmit.shipments
          .map((shipment) => {
            return shipment.pieceType;
          })
          .includes(pieceTypeValue);
      });
      // const setOrderData = row.isMergedOrder
      //   ? setMergedRows
      //   : setCDKOrderTableData;
      setCDKOrderTableData((oldData) => {
        return oldData.map((oldRow, index) => {
          if (rowEqualityCheck(oldRow, row)) {
            //loop through the rows, and if we are at the row that we want to update, update it
            return {
              ...oldRow,
              dataToSubmit: {
                ...oldRow.dataToSubmit,
                shipments: [
                  ...oldRow.dataToSubmit.shipments,
                  {
                    comments: oldRow.dataToSubmit.shipments[0].comments ?? "",
                    numShippingLabels: 1,
                    pieceType: pieceTypeToAdd,
                    declaredValue: 0,
                    CODType: oldRow.dataToSubmit.shipments[0].CODType,
                    insurance: oldRow.dataToSubmit.shipments[0].insurance,
                  },
                ],
              },
            };
          } else {
            return oldRow; //otherwise return the row as it was (for all the rest).
          }
        });
      });
    },
    [setCDKOrderTableData]
  );

  const removeElementAtIndex = (array, index) => {
    let newArray = [...array];
    newArray.splice(index, 1);
    return newArray;
  };

  const handleRemoveShipment = useCallback(
    (e, row, shipmentIndex) => {
      // const setOrderData = row.isMergedOrder
      //   ? setMergedRows
      //   : setCDKOrderTableData;
      setCDKOrderTableData((oldData) => {
        return oldData.map((oldRow, index) => {
          if (rowEqualityCheck(oldRow, row)) {
            //if we get a match for row ID, delete a shipment from that row
            return {
              ...oldRow,
              dataToSubmit: {
                ...oldRow.dataToSubmit,
                shipments: removeElementAtIndex(
                  oldRow.dataToSubmit.shipments,
                  shipmentIndex
                ),
              },
            };
          } else {
            return oldRow; //otherwise return the row as it was.
          }
        });
      });
    },
    [setCDKOrderTableData]
  );

  const handleEditShipment = useCallback(
    (e, row, shipmentIndex) => {
      // console.log(row.dataToSubmit.shipments);
      const name = e.target.name;
      const finalValue =
        e.target.type === "checkbox" ? e.target.checked : e.target.value;

      if (name === "numShippingLabels" && row.isMergedOrder) {
        const shipmentTypeAttemptingToEdit =
          row.dataToSubmit.shipments[shipmentIndex].pieceType;
        // console.log("row", row);
        const originalRowsShipments = row.originalRows.reduce(
          (rollingShipmentsArray, currentOriginalRow) => {
            return [
              ...rollingShipmentsArray,
              ...currentOriginalRow.dataToSubmit.shipments,
            ];
          },
          []
        );
        // console.log("all shipments from original rows", originalRowsShipments);
        const totalQuantitiesOfThatTypeBeforeMerge = originalRowsShipments
          .filter(
            (shipment) => shipment.pieceType === shipmentTypeAttemptingToEdit
          )
          .reduce((rollingPieceCount, currentShipment) => {
            return (rollingPieceCount += parseInt(
              currentShipment.numShippingLabels
            ));
          }, 0);
        // console.log(
        //   "total #shipping labels for piece type before merge",
        //   totalQuantitiesOfThatTypeBeforeMerge
        // );
        if (parseInt(e.target.value) > totalQuantitiesOfThatTypeBeforeMerge) {
          // console.log("no increase");
          toast.warning(
            "Packages may only be decreased after merging. Please configure piece types and number of shipping labels before merging."
          );
          return;
        }
      }

      const newShipment = {
        ...row.dataToSubmit.shipments[shipmentIndex],
        [name]: finalValue,
      };

      // console.log(e.target.name);
      // console.log(e.target.value);
      // console.log(row);
      //Adjusting these functions to account for new merged order rows.
      //Use the appropriate state setter based on whether the order is merged or not.
      // const setOrderData = row.isMergedOrder
      //   ? setMergedRows
      //   : setCDKOrderTableData;
      // setCDKOrderTableData((oldData) => {
      setCDKOrderTableData((oldData) => {
        return oldData.map((oldRow, index) => {
          if (rowEqualityCheck(oldRow, row)) {
            //if we get a match for row ID, update that row
            // console.log("matched ------------");
            // console.log(e.target.name);
            // console.log(e.target.value);
            // console.log(oldRow.dataToSubmit.shipments);
            if (name === "numShippingLabels") {
              //to limit the max amount of shipping labels to CDK # parts:
              //if numShippingLabels is being updated,
              //let's generate what it would be when updated
              //if the total would add up to over the CDK # parts
              //we return so as to not actually update it
              const newShipmentsArray = generateUpdatedShipmentArrayAtIndex(
                oldRow.dataToSubmit.shipments,
                shipmentIndex,
                newShipment
              );
              if (
                newShipmentsArray.reduce((rollingSum, shipment) => {
                  return (rollingSum += parseInt(
                    shipment.numShippingLabels ? shipment.numShippingLabels : 0
                  ));
                }, 0) > row.dataToSubmit.CDKNumParts
              ) {
                return oldRow;
              }
            }
            return {
              ...oldRow,
              dataToSubmit: {
                ...oldRow.dataToSubmit,
                shipments: generateUpdatedShipmentArrayAtIndex(
                  oldRow.dataToSubmit.shipments,
                  shipmentIndex,
                  newShipment
                ),
              },
            };
          } else {
            return oldRow; //otherwise return the row as it was.
          }
        });
      });
    },
    [setCDKOrderTableData]
  );
  const [finalizedOrder, setFinalizedOrder] = useState();
  const [finalizedOrderLabelPDFs, setFinalizedOrderLabelPDFs] = useState();

  const [finalizeOrderModalState, setFinalizeOrderModalState] = useState(
    finalizationModalStates.hidden
  );

  // const handleOpenFinalizeOrderModal = ()=>{
  //   setShowFinalizeOrderModal(true);
  // }
  const handleCloseFinalizeOrderModal = () => {
    setFinalizeOrderModalState(finalizationModalStates.hidden);
  };

  const handleFinalizeOrder = useCallback(
    async (order) => {
      // console.log(order);
      //validation
      const { isValid, reasons } = isValidCDKOrderSubmission(order);
      if (!isValid) {
        toast.error(
          "Issues with order\n" +
            reasons.reduce((rollingMessage, currentMessage) => {
              return rollingMessage + "\n" + currentMessage;
            })
        );
        return;
      }

      setFinalizedOrder(order); // set finalizedOrder (just so the finalization modal has a reference to it)
      //if the order's wasSubmitted flag is not already true, set it to true to allow unedited DilitextCPs to start showing errors.
      if (!order.wasSubmitted) {
        setCDKOrderTableData((oldData) => {
          return oldData.map((oldRow, index) => {
            if (rowEqualityCheck(oldRow, order)) {
              //usually i call it row, but here order for now
              return {
                ...oldRow,
                wasSubmitted: true,
              };
            } else {
              return oldRow;
            }
          });
        });
      }

      //build order body that we will post
      let orderBody = {
        deliveryId: 0,
        CdkOrderId: order.CDKOrderID,
        invoiceNumber: order.dataToSubmit.invoiceNumber,
        customerName: order.dataToSubmit.customerName,
        customerAddress: order.dataToSubmit.customerAddress.address,
        customerCity: order.dataToSubmit.customerAddress.city,
        customerStateAbbreviation: order.dataToSubmit.customerAddress.state,
        customerZipCode: order.dataToSubmit.customerAddress.zip,
        customerPhoneNumber: "",
        pieceCount: order.dataToSubmit.shipments[0].numShippingLabels,
        pieceType: order.dataToSubmit.shipments[0].pieceType,
        amount: order.dataToSubmit.shipments[0].declaredValue,
        comment: order.dataToSubmit.shipments[0].comments,
        codType: order.dataToSubmit.shipments[0].CODType,
        timeCode: order.dataToSubmit.timeCode,
        wantsValuationCoverage: order.dataToSubmit.shipments[0].insurance,
        refNo: "CDK",
        dropShipClientId: "",
        // customerId: 0,
        Cod_Default: false,
        Cash_Default: false,
        isDefaultChecked: false,
        weight: 0,
        PieceTypeList: order.dataToSubmit.shipments.slice(1).map((shipment) => {
          return {
            numPieces: shipment.numShippingLabels,
            pieceTypeString: shipment.pieceType,
            amount: shipment.declaredValue,
            cType: shipment.CODType,
            coverage: shipment.insurance,
            comments: shipment.comments,
          };
        }),
      };
      if (order.isMergedOrder) {
        orderBody.combinationInvoicesList = order.mergedInvoiceDetails;
      }

      try {
        //post the order, then use the deliver ids that are returned to get labels;
        // console.log(orderBody);
        setFinalizeOrderModalState(finalizationModalStates.finalizingOrder);
        const response = await (order.isMergedOrder
          ? postMergedCDKOrder(orderBody)
          : postCDKOrder(orderBody));
        const deliveryIdString = response.data
          .map((delivery) => {
            return delivery.deliveryId;
          })
          .join(",");
        await updateCDKOrderIsImportedField({ Id: [order.CDKOrderID] });
        updateCDKOrderMainFields(order, "isImported", true);

        //if the order was a merged order maybe mark the individual orders as imported as well, but they "should" stay hidden anyway, since we keep them in the hidden mergedRowIds state.
        if (order.isMergedOrder) {
          // const originalRowIDs = order.originalRows.map(
          //   (row) => row.CDKOrderID
          // );
          multiUpdateCDKOrderMainFields(order.originalRows, "isImported", true);
        }
        // console.log(deliveryIdString);
        const labelResponse = await getLabelsForCDKDeliveries(
          deliveryIdString,
          false,
          isClient()
        );
        const reader = new FileReader();
        reader.readAsDataURL(labelResponse.data);
        reader.onloadend = () => {
          setFinalizedOrderLabelPDFs(reader.result);
          setFinalizeOrderModalState(finalizationModalStates.labelsRetrieved);
          toast.success("Order successfully placed.");
          // console.log(response);
        };
      } catch (ex) {
        handleApiError(ex, history);
        setFinalizeOrderModalState(finalizationModalStates.error);
      }
    },
    [setCDKOrderTableData]
  );

  const [showMultiFinalizeModal, setShowMultiFinalizeModal] = useState(false);
  // const [multiFinalizeResults, setMultiFinalizeResults] = useState([]);
  const handleOpenMultiFinalizeModal = () => {
    setShowMultiFinalizeModal(true);
  };
  const handleHideMultiFinalizeModal = () => {
    setShowMultiFinalizeModal(false);
  };

  const [showGuide, setShowGuide] = useState(false);
  const handleOpenGuidemodal = () => {
    setShowGuide(true);
  };
  const handleHideGuideModal = () => {
    setShowGuide(false);
  };

  const canMergeSelected = () => {
    // console.log("can merge");
    const multipleRowsSelected = selectedRows.length > 1;
    //for now they can not merge more orders into already merged orders.
    if (
      selectedRows.filter((row) => {
        return row.isMergedOrder;
      }).length > 0
    ) {
      return false;
    }
    const allRowsHaveSameDestination =
      selectedRows.filter((row) => {
        return (
          row.dataToSubmit.customerAddress.address ===
          selectedRows?.[0]?.dataToSubmit.customerAddress.address
        );
      }).length === selectedRows.length;
    // all rows must have at least a package piece type to be able to be merged, with the exception of: 1 row can have a pallet piece type without a package
    let numRowsThatHavePackagePieceType = 0;
    let numRowsThatHavePalletPieceTypeWithoutPackage = 0;
    // console.log("can merge", selectedRows.length);
    for (let i = 0; i < selectedRows.length; i++) {
      // console.log("can merge loop iterations", i);
      const currentRowShipments = selectedRows[i].dataToSubmit.shipments;
      let hasPackage = false;
      let hasPallet = false;
      for (let j = 0; j < currentRowShipments.length; j++) {
        // console.log("can merge", currentRowShipments[j]);
        // console.log("can merge", newPieceTypes.Package.value);
        if (currentRowShipments[j].pieceType === newPieceTypes.Package.value) {
          hasPackage = true;
          // console.log("can merge had packageeee");
        } else if (
          currentRowShipments[j].pieceType === newPieceTypes.Pallet.value
        ) {
          hasPallet = true;
        }
      }
      if (hasPackage) {
        //if it had a package in the shipments, increment our counter. If the order has a package we can disregard the pallet check.
        numRowsThatHavePackagePieceType++;
      } else if (hasPallet) {
        //if it had no packages but it has a pallet we increment the other counter
        numRowsThatHavePalletPieceTypeWithoutPackage++;
      }
    }

    //basically either all orders have at least 1 package
    //or all but 1 orders have a package, and the one that doesn't have a package has a pallet
    // console.log(
    //   "can merge, num rows with package piece type",
    //   numRowsThatHavePackagePieceType
    // );
    const meetsPieceTypeRules =
      numRowsThatHavePackagePieceType === selectedRows.length ||
      (numRowsThatHavePackagePieceType === selectedRows.length - 1 &&
        numRowsThatHavePalletPieceTypeWithoutPackage === 1);

    const canMerge =
      multipleRowsSelected && allRowsHaveSameDestination && meetsPieceTypeRules;
    // console.log("can merge, multiple rows selected", multipleRowsSelected);
    // console.log(
    //   "can merge, all rows have same destination",
    //   allRowsHaveSameDestination
    // );
    // console.log("can merge, meets piece type rules", meetsPieceTypeRules);
    // console.log("Can Merge, all checks passed", canMerge);
    return canMerge;
  };
  // const [showMergeOrderModal, setShowMergeOrderModal] = useState(false);
  const handleClickMergeSelected = () => {
    // let mergedRowsBuilder = {
    // }
    // console.log(selectedRows);
    //const mergedCDKSubInvoiceTemplate = {
    //   deliveryId: 0,
    //   cdkInvoiceNumber: "",
    //   pieceType: "",
    //   pieceQuantity: 0,
    // };
    //must assemble a list of mergedInvoice

    //the spread operator creates a shallow copy, and modifications to nested objects will affect the original row
    // let mergedOrder = { ...selectedRows[0] };
    //So instead, make a deep clone of the first selected row
    //a deep clone is necessary so we don't modify the original row's nested elements
    //alternatively, we could create the merged order object from scratch
    let mergedOrder = cloneDeep(selectedRows[0]);
    mergedOrder["originalRows"] = [...selectedRows];
    mergedOrder["mergedInvoiceDetails"] = [];
    mergedOrder.isSelected = false; //deselect the new merged order
    handleDeselectAllRows(); //deselect previously selected rows.
    let mergedShipments = {};
    let totalParts = 0;
    for (let i = 0; i < selectedRows.length; i++) {
      const currentRow = selectedRows[i];
      totalParts += currentRow.dataToSubmit.CDKNumParts;
      //a single invoice/order will need to have a separate merged/combination Invoice Details Object for each unique piece type.
      let mergedInvoiceDetailsElementsForCurrentInvoice = [];
      for (let i = 0; i < currentRow.dataToSubmit.shipments.length; i++) {
        const currentShipment = currentRow.dataToSubmit.shipments[i];
        mergedInvoiceDetailsElementsForCurrentInvoice.push({
          deliveryId: 0,
          cdkInvoiceNumber: currentRow.dataToSubmit.invoiceNumber,
          pieceType: currentShipment.pieceType,
          pieceQuantity: currentShipment.numShippingLabels,
        });
        if (!mergedShipments[currentShipment.pieceType]) {
          mergedShipments[currentShipment.pieceType] = { ...currentShipment }; //set to a copy of the shipment so we do not modify the original rows
        } else {
          //Add up shipping labels per piece type
          const shipmentTypeToModify =
            mergedShipments[currentShipment.pieceType];
          shipmentTypeToModify.numShippingLabels =
            parseInt(shipmentTypeToModify.numShippingLabels) +
            parseInt(currentShipment.numShippingLabels);
          //Add up declared value per piece type
          shipmentTypeToModify.declaredValue = (
            parseFloat(shipmentTypeToModify.declaredValue) +
            parseFloat(currentShipment.declaredValue)
          ).toFixed(2);
          if (currentShipment.comments) {
            //Concat comments with separator, if the shipment has one.
            //We will trim to comment limit later, and allow clients to see original comments with different merge/overwrite options in the comment editing modal for these merged orders.
            shipmentTypeToModify.comments = shipmentTypeToModify.comments //if there are already comments we want to append the current comments after a separator
              ? shipmentTypeToModify.comments + "| " + currentShipment.comments
              : currentShipment.comments; //if there are no comments yet, we just want to add the first comment
          }
          //If insurance was checked for any order shipment type, just set it to true for the merged shipment type for now. Client can change again before finalization.
          if (currentShipment.insurance) {
            shipmentTypeToModify.insurance = true;
          }
          // mergedShipments[currentShipment.pieceType] = {
          //   numShippingLabels: ,
          //   pieceType,
          //   declaredValue,
          //   comments,
          //   insurance,
          //   CODType,
          //   mergedShipments[currentShipment.pieceType]
          // };
        }
      }

      // console.log("merged shipments");
      // console.log(mergedShipments);

      mergedOrder["mergedInvoiceDetails"] = [
        ...mergedOrder.mergedInvoiceDetails,
        ...mergedInvoiceDetailsElementsForCurrentInvoice,
      ];
    }
    // mergedOrder["mergedShipments"] = mergedShipments
    //since the merged row is just a copy, it should be fine to just overwrite the usual shipments
    //=======================================================
    //Full rules for shipment editing for a merged order row:
    //Only package quantities may be reduced (I.e. (combined physically, into less packages)). No other piece type's quantity may be edited.
    //If there is a pallet, packages may be removed entirely (i.e. all packages may be combined physically with the pallets).

    //if the order is a merged order, move pallet piece type to the top
    //this is because the first piece type cannot be removed at all, and
    //when merging orders packages can be merged into pallets.
    //I.e. they can remove the package piece type entirely but not pallets.
    mergedOrder.dataToSubmit.shipments = Object.values(mergedShipments)
      .map((mergedShipment) => {
        return {
          ...mergedShipment,
          comments: mergedShipment.comments.substring(0, commentLimit),
        };
      })
      .sort((a, b) => {
        if (a.pieceType === newPieceTypes.Pallet.value) {
          return -1;
        } else if (b.pieceType === newPieceTypes.Pallet.value) {
          return 1;
        } else {
          return 0;
        }
      });

    // let mergedRowWithPallet = false;
    //   if (
    //     mergedOrder.dataToSubmit.shipments.some((shipment) => {
    //       return shipment.pieceType === newPieceTypes.Pallet.value;
    //     })
    //   ) {
    //     mergedRowWithPallet = true;
    //   }
    // }

    mergedOrder["isMergedOrder"] = true;
    mergedOrder.dataToSubmit.CDKNumParts = totalParts;
    //
    // mergedShipments TODO
    //reset mergedShipment COD Type to none and have them select again
    //WORK ON COMMENTS, INSURANCE

    // const mergedOrder = selectedRows.reduce(
    //   (mergedOrderBuilder, currentRow) => {
    //     console.log("Begin merge order reduction=============");
    //     console.log(currentRow.dataToSubmit.invoiceNumber);
    //     console.log(currentRow.dataToSubmit.shipments);

    //     // let mergedInvoiceDetailsElement = {
    //     //   deliveryId: 0,
    //     //   cdkInvoiceNumber: "",
    //     //   pieceType: "",
    //     //   pieceQuantity: 0,
    //     // };
    //     //a single invoice/order will need to have a separate merged/combination Invoice Details Object for each unique piece type.
    //     let mergedInvoiceDetailsElementsForCurrentInvoice = [];
    //     for (let i = 0; i < currentRow.dataToSubmit.shipments.length; i++) {
    //       const currentShipment = currentRow.dataToSubmit.shipments[i];
    //       mergedInvoiceDetailsElementsForCurrentInvoice.push({
    //         deliveryId: 0,
    //         cdkInvoiceNumber: currentRow.dataToSubmit.invoiceNumber,
    //         pieceType: currentShipment.pieceType,
    //         pieceQuantity: currentShipment.numShippingLabels,
    //       });
    //     }
    //     //need to combine declared values and shipments
    //     return {
    //       ...mergedOrderBuilder,
    //       mergedInvoiceDetails: [
    //         ...mergedOrderBuilder.mergedInvoiceDetails,
    //         ...mergedInvoiceDetailsElementsForCurrentInvoice,
    //       ],
    //     };
    //   },
    //   selectedRows[0]
    // );
    setCDKOrderTableData((oldData) => {
      return [mergedOrder, ...oldData];
    });
    // setMergedRows((prev) => {
    //   return [...prev, mergedOrder];
    // });
    const selectedRowIds = selectedRows.map((row) => {
      return row.CDKOrderID;
    });
    setMergedRowIds((prev) => {
      return [...prev, ...selectedRowIds];
    });
    // const newOrderData = cdkOrderTableData.filter((row) => {
    //   return !selectedRowIds.includes(row.CDKOrderID);
    // });
    // setShowMergeOrderModal(true);
  };
  const handleClickUnMergeSelected = (rowToUnMerge) => {
    //right now the un merge button is only available if the only selection is a single merged order
    //so we can grab the first row from the selected mergedRows array
    //alternatively we could pass in the row as a parameter.
    // const rowToUnMerge = selectedMergedRows[0];
    // console.log("ROW TO UNMERGE", rowToUnMerge);
    //Get all the ids of the orders the merged order contains
    //then remove them from the mergedRowIds array to make them show as normal rows again (we filter out the mergedRowIds from the normal orders, so removing them will bring them back)
    const rowToUnMergeOriginalOrderIds = rowToUnMerge.originalRows.map(
      (row) => {
        return row.CDKOrderID;
      }
    );
    // console.log("ROW TO UNMERGE ORDER IDS", rowToUnMergeOriginalOrderIds);
    setMergedRowIds((oldData) => {
      return oldData.filter((rowId) => {
        // console.log("row ID", rowId);
        //remove the row ids this order had from the mergedRowIds state array
        return !rowToUnMergeOriginalOrderIds.includes(rowId);
      });
    });
    //remove the row from CDK order table data
    //todo
    //Remove the row from the state array
    setCDKOrderTableData((oldData) => {
      return oldData.filter((row) => {
        // console.log(row.CDKOrderID);
        // console.log(rowToUnMerge.CDKOrderID);
        return !(
          row.isMergedOrder && row.CDKOrderID === rowToUnMerge.CDKOrderID
        );
      });
    });
  };
  // console.log(mergedRowIds);
  // const handleHideMergeOrderModal = () => {
  //   setShowMergeOrderModal(false);
  // };
  // const handleFinalizeAll = useCallback(() => {}, [
  //   setCDKOrderTableData,
  // ]);

  const handleClickInvoiceChip = (invoice) => {
    navigator.clipboard.writeText(invoice);
    toast.success("Invoice number copied to clipboard.", { autoClose: 2500 });
  };

  //HideMultiCDKOrderConfirmModal===========================
  const [
    showHideMultiCDKOrderConfirmModal,
    setShowHideMultiCDKOrderConfirmModal,
  ] = useState(false);
  const handleOpenHideMultiCDKOrderConfirmModal = () => {
    setShowHideMultiCDKOrderConfirmModal(true);
  };
  const handleHideHideMultiCDKOrderConfirmModal = () => {
    setShowHideMultiCDKOrderConfirmModal(false);
  };
  //HiddenOrdersRestorationModal======================
  // const [showHiddenOrderRestorationModal, setShowHiddenOrderRestorationModal] =
  //   useState(false);
  // const handleOpenHiddenOrdersRestorationModal = () => {
  //   setShowHiddenOrderRestorationModal(true);
  // };
  // const handleHideHiddenOrdersRestorationModal = () => {
  //   setShowHiddenOrderRestorationModal(false);
  // };

  //Headers=========================
  const Fields = useMemo(
    () => [
      {
        HeaderRender: () => {
          return (
            <div
              style={{
                // backgroundColor: "red",
                display: "grid",
                height: "100%",
                placeContent: "center",
              }}
            >
              <input
                type="checkbox"
                // checked={selectAllState}
                // ref={(input) => {
                //   if (input) {
                //     input.indeterminate = true;
                //   }
                // }}
                ref={(input) => {
                  if (input) {
                    if (
                      tableDataToDisplay.length > 0 &&
                      tableDataToDisplay.every((row) => {
                        return row.isSelected;
                      })
                    ) {
                      input.checked = true;
                      input.indeterminate = false;
                    } else if (
                      tableDataToDisplay.every((row) => {
                        return !row.isSelected;
                      })
                    ) {
                      input.checked = false;
                      input.indeterminate = false;
                    } else {
                      input.indeterminate = true;
                    }
                  }
                }}
                onChange={handleSelectPage}
              />
            </div>
          );
        },
        id: "selection",

        width: 30,
        Render: (rowData) => {
          return (
            <div
              style={{
                // display: "grid",
                // height: "100%",
                // placeContent: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  height: "40px",
                  width: "40px",
                  display: "grid",
                  placeContent: "center",
                }}
              >
                <input
                  type="checkbox"
                  // value={rowData.isSelected}
                  checked={rowData.isSelected}
                  onChange={(e) => {
                    handleSelectRow(e, rowData);
                  }}
                />
              </div>
            </div>
          );
        },
      },
      {
        Header: "",
        id: "expander",

        width: 50,
        Render: (rowData) => {
          return (
            <div
              style={{
                // display: "grid",
                // height: "100%",
                // placeContent: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {rowData.isExpanded ? (
                <button
                  onClick={(e) => {
                    handleExpandRow(e, rowData);
                  }}
                  className="btn btn-primary order-history-expander-button"
                >
                  <BsDash />
                </button>
              ) : (
                <button
                  onClick={(e) => {
                    handleExpandRow(e, rowData);
                  }}
                  className="btn btn-primary order-history-expander-button"
                >
                  <BsPlus />
                </button>
              )}
            </div>
          );
        },
      },
      // {
      //   Header: "ID",
      //   HeaderRender: (accessor) => {
      //     return (
      //       <div
      //         className="clickable"
      //         onClick={() => {
      //           handleChangeSortColumn(accessor);
      //         }}
      //       >
      //         ID
      //         <SortArrow
      //           isSorted={
      //             sortByColumn.column === accessor &&
      //             sortByColumn.state !== sortByStates.none
      //           }
      //           isSortedDesc={sortByColumn.state === sortByStates.desc}
      //         />
      //       </div>
      //     );
      //   },
      //   accessor: "CDKOrderID",
      //   width: 90,
      //   Filter: () => {
      //     return (
      //       <div>
      //         <DiliTextCP
      //           name="CDKOrderID"
      //           value={filters.CDKOrderID}
      //           onChange={handleChangeFilter}
      //           placeholder={
      //             "Search " + filteredTableData.length + " records..."
      //           }
      //           inputClass="form-control form-control-sm order-history-table-filters"
      //         />
      //       </div>
      //     );
      //   },
      // },
      {
        Header: "Invoice",
        accessor: "dataToSubmit.invoiceNumber",
        width: 120,
        Filter: () => {
          return (
            <div>
              <DiliTextCP
                name="invoiceNumber"
                value={filters.invoiceNumber}
                onChange={handleChangeFilter}
                placeholder={
                  "Search " + filteredTableData.length + " records..."
                }
                inputClass="form-control form-control-sm order-history-table-filters"
              />
            </div>
          );
        },
        Render: (row) => {
          return (
            <Chips
              items={
                row.originalRows
                  ? row.originalRows.map((row) => {
                      return row.dataToSubmit.invoiceNumber;
                    })
                  : [row.dataToSubmit.invoiceNumber]
              }
              onClickChip={handleClickInvoiceChip}
            />
          );
        },
      },
      {
        //editable through modal
        Header: "Customer",
        accessor: "dataToSubmit.customerAddress.address",
        width: 350,
        Render: (row) => {
          const noTimeCodesFound =
            row.dataToSubmit.didInitialTimeCodeFetch &&
            row.dataToSubmit.timeCodes?.length === 0;
          return (
            <div
            // className={noTimeCodesFound ? "border border-danger rounded" : ""}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: ".5rem",
                }}
              >
                <div>
                  <div className="line-clamp-base line-clamp-3">
                    {row.dataToSubmit.customerName}
                    <br />
                    {row.dataToSubmit.customerAddress.address
                      ? row.dataToSubmit.customerAddress.address + " | "
                      : ""}
                    {assembleCityStateZipWithNotFound(
                      row.dataToSubmit.customerAddress.city,
                      row.dataToSubmit.customerAddress.state,
                      row.dataToSubmit.customerAddress.zip
                    )}
                  </div>
                </div>
                <div
                  style={
                    {
                      // backgroundColor: "red",
                      // zIndex: 50000,
                      // left: 0,
                      // bottom: 0,
                    }
                  }
                >
                  <button
                    className="btn p-0 shadow-none"
                    onClick={() => {
                      openEditCustomerModal(row);
                    }}
                  >
                    <BsPencilSquare
                      className="text-note"
                      style={{ verticalAlign: "baseline" }}
                    />
                  </button>
                </div>
              </div>
              {noTimeCodesFound ? (
                <div className="text-note font-extra-small text-danger">
                  No time codes found. Please make sure city and state are
                  correct. If the issue persists, contact Diligent Support.
                </div>
              ) : (
                ""
              )}
            </div>
          );
        },
        Filter: () => {
          return (
            <div>
              <DiliTextCP
                name="customer"
                value={filters.customer}
                onChange={handleChangeFilter}
                placeholder={
                  "Search " + filteredTableData.length + " records..."
                }
                inputClass="form-control form-control-sm order-history-table-filters"
              />
            </div>
          );
        },
      },
      {
        //editable through modal
        Header: "Comments",
        accessor: "dataToSubmit.comments",
        width: 170,
        Render: (row) => {
          return row.dataToSubmit.shipments.map((shipment, index) => {
            return (
              <div
                key={index}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "1rem",
                }}
              >
                <div className="line-clamp-base line-clamp-2">
                  {shipment.comments}
                </div>
                <div
                  style={
                    {
                      // backgroundColor: "red",
                      // zIndex: 50000,
                      // left: 0,
                      // bottom: 0,
                    }
                  }
                >
                  <button
                    className="btn p-0 shadow-none"
                    onClick={() => {
                      openEditCommentsModal(row, index);
                    }}
                  >
                    <BsPencilSquare
                      className="text-note"
                      style={{ verticalAlign: "baseline" }}
                    />
                  </button>
                </div>
              </div>
            );
          });
        },
        Filter: () => {
          return (
            <div>
              <DiliTextCP
                name="comments"
                value={filters.comments}
                onChange={handleChangeFilter}
                placeholder={
                  "Search " + filteredTableData.length + " records..."
                }
                inputClass="form-control form-control-sm order-history-table-filters"
              />
            </div>
          );
        },
      },

      {
        // Header: "# Parts",
        HeaderRender: (accessor) => {
          return (
            <div
              className="clickable"
              // onClick={handleChangeSortByNumParts}
              onClick={() => {
                handleChangeSortColumn(accessor);
              }}
            >
              # Parts
              <br />
              <SortArrow
                isSorted={
                  sortByColumn.column === accessor &&
                  sortByColumn.state !== sortByStates.none
                }
                isSortedDesc={sortByColumn.state === sortByStates.desc}
              />
            </div>
          );
        },
        accessor: "dataToSubmit.CDKNumParts",
        width: 80,
      },
      {
        Header: "# Shipping Labels",
        accessor: "dataToSubmit.numShippingLabels",
        width: 110,
        Render: (row) => {
          // console.log(row.dataToSubmit.shipments);
          // console.log("shipments: " + row.dataToSubmit.shipments.length);
          return row.dataToSubmit.shipments.map((shipment, index) => {
            // console.log("shipment number: " + indexo);
            return (
              <DiliTextCP
                className="cdk-shipment-margin-bottom"
                key={index}
                type="number"
                blockScientificNotation
                positiveOnly
                integerOnly
                max={99}
                min={1}
                name="numShippingLabels"
                value={shipment.numShippingLabels}
                disabled={
                  row.isMergedOrder &&
                  shipment.pieceType !== newPieceTypes.Package.value
                }
                onChange={(e) => {
                  handleEditShipment(e, row, index);
                }}
              />
            );
          });
        },
      },
      {
        Header: "Piece Type",
        accessor: "dataToSubmit.pieceType",
        width: 150,
        Render: (row) => {
          return row.dataToSubmit.shipments.map((shipment, index) => {
            // console.log("Editing numLabels: " + shipment.numShippingLabels);
            // console.log("Parts: " + row.dataToSubmit.CDKNumParts);
            // console.log(
            //   parseInt(shipment.numShippingLabels) === parseInt(row.dataToSubmit.CDKNumParts)
            // );
            //if the total amount of labels currently entered in is = to the # parts (which for now is the max amount of labels we want to allow)
            //disable the add shipment button

            const totalLabels = row.dataToSubmit.shipments.reduce(
              (rollingSum, shipment) => {
                return (rollingSum += parseInt(shipment.numShippingLabels));
              },
              0
            );
            const addButtonDisabled =
              row.isMergedOrder ||
              totalLabels >= parseInt(row.dataToSubmit.CDKNumParts) ||
              row.dataToSubmit.shipments.length ===
                Object.keys(newPieceTypes).length;
            return (
              <div
                key={index}
                className="cdk-shipment-margin-bottom"
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {index === 0 ? (
                  <button
                    className={
                      "btn" +
                      (addButtonDisabled
                        ? ""
                        : " cdk-add-shipment-button-transition")
                    }
                    style={{ padding: ".2rem" }}
                    onClick={(e) => {
                      handleAddShipment(e, row);
                    }}
                    disabled={addButtonDisabled}
                  >
                    <BsPlusCircle
                      visibility={
                        row.dataToSubmit.shipments.length ===
                        Object.keys(newPieceTypes).length
                          ? "hidden"
                          : ""
                      }
                    />
                  </button>
                ) : (
                  <button
                    className="btn"
                    style={{ padding: ".2rem" }}
                    disabled={
                      row.isMergedOrder &&
                      !(
                        shipment.pieceType === newPieceTypes.Package.value &&
                        row.dataToSubmit.shipments.find(
                          (shipment) =>
                            shipment.pieceType === newPieceTypes.Pallet.value
                        )
                      )
                    }
                    onClick={(e) => {
                      handleRemoveShipment(e, row, index);
                    }}
                  >
                    <BsDashCircle className="cdk-add-shipment-button" />
                  </button>
                )}
                <DiliTextCP
                  className="w-100"
                  type="select"
                  name="pieceType"
                  value={shipment.pieceType}
                  onChange={(e) => {
                    handleEditShipment(e, row, index);
                  }}
                >
                  {Object.keys(newPieceTypes)
                    .filter((pieceType) => {
                      // console.log(
                      //   row.dataToSubmit.shipments.map((shipment) => {
                      //     return shipment.pieceType;
                      //   })
                      // );
                      return (
                        shipment.pieceType === newPieceTypes[pieceType].value ||
                        !row.dataToSubmit.shipments
                          .map((shipment) => {
                            return shipment.pieceType;
                          })
                          .includes(newPieceTypes[pieceType].value)
                      );
                    })
                    .map((pieceType, index) => {
                      return (
                        <option
                          key={index}
                          value={newPieceTypes[pieceType].value}
                        >
                          {newPieceTypes[pieceType].display}
                        </option>
                      );
                    })}
                  {/* {Object.keys(pieceTypes).map((pieceType) => {
                return (
                  <option value={pieceTypes[pieceType].value}>
                    {pieceTypes[pieceType].display}
                  </option>
                );
              })} */}
                  {/* <option value="">Package</option>
                  <option value={pieceTypes.Pallet.value}>
                    {pieceTypes.Pallet.display}
                  </option>
                  <option value={pieceTypes.Engine.value}>
                    {pieceTypes.Engine.display}
                  </option>
                  <option value={pieceTypes.Transmission.value}>
                    {pieceTypes.Transmission.display}
                  </option>
                  <option value={pieceTypes.Oversized.value}>
                    {pieceTypes.Oversized.display}
                  </option> */}
                </DiliTextCP>
              </div>
            );
          });
        },
      },
      {
        Header: "Declared Value",
        accessor: "dataToSubmit.declaredValue",
        width: 100,
        Render: (row) => {
          return row.dataToSubmit.shipments.map((shipment, index) => {
            return (
              <DiliTextCP
                className="cdk-shipment-margin-bottom"
                key={index}
                type="number"
                blockScientificNotation
                max="999999999"
                decimalPrecision={2}
                value={shipment.declaredValue}
                // invalidText={
                //   shipment.declaredValue < 0
                //     ? "Value must not be negative."
                //     : ""
                // }
                problemText={
                  shipment.declaredValue < 0
                    ? "Value must not be negative."
                    : shipment.CODType !== codOptions.None.value
                    ? "Please enter a value for COD orders."
                    : ""
                }
                showProblemText={
                  shipment.CODType !== codOptions.None.value
                    ? shipment.declaredValue <= 0
                    : shipment.declaredValue < 0
                }
                helperTextClass="font-extra-small"
                // validationTest={(value) => {
                //   return value >= 0;
                // }}
                wasSubmitted={row.wasSubmitted}
                name="declaredValue"
                onChange={(e) => {
                  handleEditShipment(e, row, index);
                }}
              />
            );
          });
        },
      },
      {
        Header: "COD Type",
        accessor: "dataToSubmit.CODType",
        width: 100,
        Render: (row) => {
          return row.dataToSubmit.shipments.map((shipment, index) => {
            // console.log(shipment.CODType);
            return (
              <DiliTextCP
                className="cdk-shipment-margin-bottom"
                key={index}
                type="select"
                name="CODType"
                value={shipment.CODType}
                onChange={(e) => {
                  handleEditShipment(e, row, index);
                }}
              >
                <option value={codOptions.None.value}>
                  {codOptions.None.display}
                </option>
                <option value={codOptions.COD.value}>
                  {codOptions.COD.display}
                </option>
                <option value={codOptions.CertifiedFunds.value}>
                  {codOptions.CertifiedFunds.display}
                </option>
              </DiliTextCP>
            );
          });
        },
      },

      {
        Header: "Insurance",
        accessor: "dataToSubmit.insurance",
        width: 130,
        //this render was for when we had one insurance box that was based off the total of all the rows of declared value.
        // Render: (row) => {
        //   const totalDeclaredValue = row.dataToSubmit.shipments.reduce(
        //     (rollingSum, shipment) => {
        //       return (rollingSum += shipment.declaredValue
        //         ? parseFloat(shipment.declaredValue)
        //         : 0);
        //     },
        //     0
        //   );
        //   return (
        //     <>
        //       <div>
        //         <div>
        //           <input
        //             style={{
        //               height: "19px",
        //               width: "19px",
        //               marginBottom: 0,
        //               display: "block",
        //             }}
        //             type="checkbox"
        //             name="insurance"
        //             checked={row.dataToSubmit.insurance}
        //             onChange={(e) => {
        //               // console.log("Standard Checkbox-----------------");
        //               // console.log(e.target.checked);
        //               // console.log(e.target.value);
        //               handleEditOrder(e, row);
        //             }}
        //           />
        //         </div>
        //         <div className="text-note font-extra-small">
        //           Fee: $
        //           {/* {console.log({
        //             insurance: row.dataToSubmit.insurance,
        //             declaredValue: row.dataToSubmit.declaredValue,
        //             maximumValuationamount: jwtInfo?.MaximumValuationAmount,
        //             minimumvaluationamount: jwtInfo?.MinimumValuationAmount,
        //             valuationrate: jwtInfo?.ValuationRate / 100,
        //           })} */}
        //           {getInsuranceFee(
        //             row.dataToSubmit.insurance,
        //             totalDeclaredValue,
        //             jwtInfo?.MaximumValuationAmount,
        //             jwtInfo?.MinimumValuationAmount,
        //             jwtInfo?.ValuationRate / 100
        //           )}
        //         </div>
        //         <div className="text-note font-extra-small">
        //           Covered: $
        //           {calculateValueCovered(
        //             row.dataToSubmit.insurance,
        //             totalDeclaredValue,
        //             jwtInfo?.MaximumValuationAmount,
        //             jwtInfo?.MinimumValuationAmount
        //           )}
        //         </div>
        //       </div>
        //       {/* <div
        //         style={{
        //           display: "flex",
        //           height: "100%",
        //           alignItems: "center",
        //           // justifyContent: "center",
        //           gap: ".2em",
        //         }}
        //       >
        //         <input
        //           type="checkbox"
        //           name="insurance"
        //           checked={row.dataToSubmit.insurance}
        //           onChange={(e) => {
        //             console.log("Standard Checkbox-----------------");
        //             console.log(e.target.checked);
        //             console.log(e.target.value);
        //             handleEditOrder(e, row);
        //           }}
        //         />
        //         <div
        //           className="text-note text-small font-small"
        //           style={{ marginTop: "-.1rem" }}
        //         >
        //           Fee: $0.00
        //         </div>
        //       </div> */}
        //     </>
        //   );
        // },
        Render: (row) => {
          return row.dataToSubmit.shipments.map((shipment, index) => {
            return (
              <div
                key={index}
                style={{
                  display: "flex",
                  // height: "100%",
                  alignItems: "center",
                  // justifyContent: "center",
                  gap: ".3rem",
                  height: "2.6rem",
                }}
              >
                <input
                  style={{
                    marginBottom: 0,
                    display: "block", //gets rid of extra space around it
                  }}
                  type="checkbox"
                  name="insurance"
                  checked={shipment.insurance}
                  onChange={(e) => {
                    // console.log("Standard Checkbox-----------------");
                    // console.log(e.target.checked);
                    // console.log(e.target.value);
                    handleEditShipment(e, row, index);
                  }}
                />
                <div>
                  <div className="text-note font-extra-small">
                    Fee: $
                    {getInsuranceFee(
                      shipment.insurance,
                      shipment.declaredValue,
                      jwtInfo?.MaximumValuationAmount,
                      jwtInfo?.MinimumValuationAmount,
                      jwtInfo?.ValuationRate / 100
                    )}
                  </div>
                  <div className="text-note font-extra-small">
                    Covered: $
                    {calculateValueCovered(
                      shipment.insurance,
                      shipment.declaredValue,
                      jwtInfo?.MaximumValuationAmount,
                      jwtInfo?.MinimumValuationAmount
                    )}
                  </div>
                </div>
              </div>
            );
          });
        },
      },
      {
        Header: "Time Code",
        accessor: "dataToSubmit.timeCode",
        width: 100,
        Render: (row) => {
          return (
            // <DiliTextCP type="select">
            //   <option value="">Select Time Code</option>
            // </DiliTextCP>
            <TimeCode
              city={row.dataToSubmit.customerAddress.city}
              state={row.dataToSubmit.customerAddress.state}
              zip={row.dataToSubmit.customerAddress.zip}
              cdkOrder={row}
              handleUpdateTimeCode={(cdkOrderID, timeCode) => {
                updateTimeCode(cdkOrderID, timeCode, row.isMergedOrder);
              }}
              handleUpdateTimeCodes={updateTimeCodes}
            />
          );
        },
      },
      {
        HeaderRender: () => {
          return <div style={{ textAlign: "center" }}>Actions</div>;
        },
        id: "actions",
        Render: (row) => {
          return (
            <div
              style={{ display: "flex", justifyContent: "center", gap: "4px" }}
            >
              {showHiddenOrders ? (
                <button
                  className="btn btn-primary"
                  onClick={(e) => {
                    handleUnhideCDKOrder(row);
                  }}
                >
                  Unhide
                </button>
              ) : (
                <>
                  {row.isMergedOrder ? (
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={(e) => {
                        //unmerge
                        handleClickUnMergeSelected(row);
                      }}
                    >
                      Unmerge
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={(e) => {
                        handleClickHideCDKRowButton(e, row);
                      }}
                    >
                      Hide
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      handleFinalizeOrder(row);
                    }}
                  >
                    Finalize
                  </button>
                </>
              )}
            </div>
          );
        },
        width: 174,
      },
    ],
    //tableDataToDisplay.length is for selectPage functionality
    [
      cdkOrderTableData,
      filters,
      // sortByNumParts,
      sortByColumn,
      tableDataToDisplay.length,
      hiddenTableData.length, //for updating the select all checkbox state when something is hidden from a page
      cdkOrderTableDataNonImported.length, //for updating the select all checkbox state when something is finalized(which also hides it from the page)
      page, //for updating select all state when changing the page, since the amount of any of the above didn't work
      showHiddenOrders,
    ]
  );

  const tableWidth = Fields.reduce((rollingSum, header) => {
    return rollingSum + header.width ?? 0;
  }, 0);

  return (
    <>
      {/* <MergeSelectedOrdersModal
        show={showMergeOrderModal}
        onHide={handleHideMergeOrderModal}
        ordersToMerge={selectedRows}
        multiUpdateCDKOrderMainFields={multiUpdateCDKOrderMainFields}
      /> */}
      <GuideModal show={showGuide} onHide={handleHideGuideModal} />
      <MultiFinalizeModal
        show={showMultiFinalizeModal}
        onHide={handleHideMultiFinalizeModal}
        ordersToFinalize={selectedRows}
        multiUpdateCDKOrderMainFields={multiUpdateCDKOrderMainFields}
      />
      <FinalizeOrderModal
        viewState={finalizeOrderModalState}
        cdkOrder={finalizedOrder}
        onHide={handleCloseFinalizeOrderModal}
        labels={finalizedOrderLabelPDFs}
      ></FinalizeOrderModal>
      <HideCDKOrderConfirmModal
        show={showHideCDKOrderConfirmModal}
        onHide={handleCancelHideCDKRow}
        cdkOrder={cdkOrderToHide}
        hideCDKOrder={handleHideCDKRow}
      />
      <HideMultiCDKOrderConfirmModal
        show={showHideMultiCDKOrderConfirmModal}
        onHide={handleHideHideMultiCDKOrderConfirmModal}
        selectedOrders={selectedRows}
        handleHideSelectedCDKRows={handleHideSelectedCDKRows}
      />
      {/* No longer used, we now just populate the table with the hidden rows. */}
      {/* <HiddenOrdersRestorationModal
        show={showHiddenOrderRestorationModal}
        onHide={handleHideHiddenOrdersRestorationModal}
        hiddenOrders={hiddenTableData}
        handleUnhide={handleUnhideCDKOrder}
      /> */}
      <EditCommentsModal
        show={isEditCommentsModalOpen}
        onHide={closeCommentsEditModal}
        finishUpdatingCommentsForOrder={finishUpdatingCommentsForOrder}
        comments={commentToEdit}
        cdkOrder={orderBeingEdited}
        shipmentIndex={shipmentIndexOfCommentBeingEdited}
      />
      <EditCDKCustomerModal
        show={isEditCustomerModalOpen}
        onHide={closeEditCustomerModal}
        finishUpdatingCustomerForOrder={finishUpdatingCustomerForOrder}
        cdkOrder={cdkOrderToEdit}
        handleUpdateTimeCodes={updateTimeCodes}
      />
      <div
        className="paper-panel-tight"
        style={{
          backgroundColor: "white",
          borderRadius: "21px",
          padding: "1.2rem",
        }}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div style={{ display: "flex", alignItems: "end", gap: "2rem" }}>
            <h3 style={{ fontWeight: "400", marginBottom: 0 }}>
              {showHiddenOrders ? "Hidden Orders" : "Imported Orders"}
            </h3>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "2rem",
                // marginBottom: "-.2rem",
              }}
            >
              <button
                className={
                  "btn cdk-hidden-orders-toggle" +
                  (showHiddenOrders
                    ? " cdk-hidden-orders-toggle-on"
                    : " cdk-hidden-orders-toggle-off")
                }
                // className="cdk-table-top-statistic-display cdk-hidden-orders-displayandbutton"
                onClick={handleToggleShowHiddenOrders}
              >
                {/* <BsRecycle
                  style={{ marginTop: "-.2rem", marginRight: ".2rem" }}
                  size=".9rem"
                /> */}
                {/* {cdkOrderTableDataNonImported.length -
                  nonHiddenTableData.length}{" "} */}
                Hidden Orders
              </button>
              <span className="cdk-table-top-statistic-display">
                {selectedRows.length} Orders Selected
              </span>
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <select
              className="form-control mr-1"
              style={{ width: "fit-content" }} //form-control width is 100%, which causes the buttons to stack for some reason
              key="sortBy"
              value={sortByColumn.column}
              onChange={handleChangeAltSortColumn}
            >
              <option value="">Sort by</option>
              {alternativeSortingOptionsArray.map((sortingOption) => {
                return (
                  <option
                    key={sortingOption[1].columnAccessor}
                    value={sortingOption[1].columnAccessor}
                  >
                    {sortingOption[1].display}
                  </option>
                );
              })}
            </select>

            <div className="btn-group" role="group" aria-label="Basic example">
              <button
                type="button"
                className="btn btn-light mr-1"
                onClick={handleClickSortOrderButton}
              >
                {sortByColumn.state === "none"
                  ? "None"
                  : sortByColumn.state === "asc"
                  ? "Asc"
                  : "Desc"}
              </button>
            </div>

            <div>
              {showHiddenOrders ? (
                //without the key, the unhide button flashes the color of the remove selected button and animates into its own color. Adding a key here insures it updates instantly
                <button
                  key="unhide-selected"
                  className="btn btn-primary mr-1"
                  type="button"
                  onClick={() => {
                    handleUnhideSelectedCDKRows(
                      // selectedRows.map((row) => {
                      //   return row.CDKOrderID;
                      // })
                      selectedRows
                    );
                  }}
                >
                  Unhide Selected
                </button>
              ) : (
                <>
                  <OverlayTrigger
                    placement="top"
                    flip
                    overlay={
                      <TooltipStandard className="tooltip-standard">
                        {canMergeSelected()
                          ? "Selected shipments may be merged. Please choose piece types before merging. Packages may be reduced later."
                          : "Merge Selected. Click on the guide icon for rules on merging orders."}
                      </TooltipStandard>
                    }
                  >
                    <button
                      key="merge-selected"
                      type="button"
                      className="btn btn-icon mr-1"
                      disabled={!canMergeSelected()}
                      onClick={handleClickMergeSelected}
                    >
                      <TbArrowMerge size={25} />
                    </button>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="top"
                    flip
                    overlay={
                      <TooltipStandard className="tooltip-standard">
                        Hide Selected
                      </TooltipStandard>
                    }
                  >
                    <button
                      key="remove-selected"
                      type="button"
                      className="btn btn-icon mr-1"
                      onClick={handleOpenHideMultiCDKOrderConfirmModal}
                      disabled={
                        selectedRows.length === 0 ||
                        selectedRows.some((row) => row.isMergedOrder)
                      }
                    >
                      <BiHide size={25} />
                    </button>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="top"
                    flip
                    overlay={
                      <TooltipStandard className="tooltip-standard">
                        Finalize Selected
                      </TooltipStandard>
                    }
                  >
                    <button
                      type="button"
                      className="btn btn-icon mr-1"
                      onClick={handleOpenMultiFinalizeModal}
                      disabled={selectedRows.length === 0}
                    >
                      <BsCheckLg size={25} />
                    </button>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="top"
                    flip
                    overlay={
                      <TooltipStandard className="tooltip-standard">
                        View Guide
                      </TooltipStandard>
                    }
                  >
                    <button
                      className="btn btn-icon"
                      type="button"
                      onClick={handleOpenGuidemodal}
                    >
                      <PiNotebookBold size={25} />
                    </button>
                  </OverlayTrigger>
                </>
              )}
              {/* <OverlayTrigger flip overlay={<TooltipStandard>Coming Soon!</TooltipStandard>}>
              <button className="btn btn-primary disabled">Finalize All</button>
            </OverlayTrigger> */}
            </div>
          </div>
        </div>
        <div className="table-responsive">
          <table
            className="table cdk-order-table-bottom-shadow"
            style={{
              marginBottom: 0,
            }}
            // style={{ tableLayout: "fixed", width: "100%" }}
          >
            {/* <thead>
            <tr
              style={{ display: "flex", width: "100%", backgroundColor: "red" }}
            >
              <th>
                <input type="checkbox" />
              </th>
              <th>CDK Order ID</th>
              <th>Customer Name</th>
              <th>Customer Address</th>
              <th>Comments</th>
              <th>Invoice Number</th>
              <th># Parts</th>
              <th># Shipping Labels</th>
              <th>Piece Type</th>
              <th>Declared Value</th>
              <th>COD Type</th>
              <th>Time Code</th>
              <th>Insurance</th>
              <th></th>
            </tr>
          </thead> */}
            <thead
            // style={{ position: "sticky", top: 0, backgroundColor: "white" }}
            >
              <tr style={{ display: "flex" }}>
                {Fields.map((field, index) => {
                  return (
                    <th
                      className="order-history-th"
                      style={{
                        // backgroundColor: `rgb(${Math.random() * 255},${
                        //   Math.random() * 255
                        // },${Math.random() * 255})`,
                        minWidth: 0,
                        width: field.width,
                        flex: `${field.width} 0 auto`,
                      }}
                      key={index + "-" + field.Header ?? field.id}
                    >
                      {field.HeaderRender
                        ? field.HeaderRender(field.accessor)
                        : field.Header}
                      {field.Filter ? field.Filter() : ""}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody
              className="cdk-order-import-table-scrollbar"
              style={{
                display: "block", //this makes it so body will have it's own scroll but also breaks the expandable panel sizing? As a workaround we calculate what the subpanel width should be based on the column definitions for now.
                height: "500px",
                overflow: "auto",
                overflowX: "hidden", //for some reason on page load, there is a little extra space on the right side, i believe it may be due to the scroll bar. Also it goes away on any action within in the table and causes a small horizontal jump. tbody, tr all seem to gain 4 px in width after it happens as well. Doing this as a workaround. Also I think this was only happening on certain screen sizes.
                // boxShadow: "0px -10px 15px -19px black inset", //this is to add shadowing at the bottom of the table, but I am going to use an absolutely positioned pseudo-element instead.
              }}
            >
              {viewState === viewStates.loading && (
                <tr
                  style={{
                    height: "100%",
                    width: "100%",
                    display: "grid",
                    placeContent: "center",
                    textAlign: "center",
                  }}
                >
                  <td style={{ border: "none" }}>
                    <div>
                      <div className="spinner-border p-3 mb-1" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                      <div>Loading Results</div>
                    </div>
                  </td>
                </tr>
              )}
              {viewState === viewStates.error && ( //if there is an error while loading data, just show an error message inside the table
                <tr
                  style={{
                    height: "100%",
                    width: "100%",
                    display: "grid",
                    placeContent: "center",
                  }}
                >
                  <td style={{ border: "none" }}>
                    <PageLoadError errorMessage="There was an issue while loading table data, please make sure you are connected to the internet and try refreshing the page." />
                  </td>
                </tr>
                // <div
                //   style={{
                //     height: "100%",
                //     width: "100%",
                //     // backgroundColor: "blue",
                //     display: "grid",
                //     placeContent: "center",
                //   }}
                // >
                //   There was an issue while loading data, please make sure you
                //   are connected to the internet and try refreshing the page.
                // </div>
              )}
              {viewState === viewStates.nodata && (
                //if there is nothing to show, let them know.
                <tr
                  style={{
                    height: "100%",
                    width: "100%",
                    display: "grid",
                    placeContent: "center",
                  }}
                >
                  <td style={{ border: "none" }}>No CDK Orders Found</td>
                </tr>
              )}
              {viewState === viewStates.success &&
              tableDataToDisplay.length === 0 ? ( //if there is nothing to show (due to filtering), let them know.
                <tr
                  style={{
                    height: "100%",
                    width: "100%",
                    display: "grid",
                    placeContent: "center",
                  }}
                >
                  <td style={{ border: "none" }}>No Results Found</td>
                </tr>
              ) : (
                <>
                  {
                    // mergedRows.map((mergedOrder, index) => {
                    //     return (
                    //       <React.Fragment key={mergedOrder.CDKOrderID}>
                    //         <tr
                    //           style={{
                    //             display: "flex",
                    //             minWidth: "0px",
                    //             flex: "1 0 auto",
                    //           }}
                    //         >
                    //           {/* <td>
                    //   <input type="checkbox" />
                    // </td>
                    // <td>
                    //   <button className="btn btn-primary order-history-expander-button">
                    //     <BsPlus />
                    //   </button>
                    // </td> */}
                    //           {Fields.map((field, index) => {
                    //             // console.log(cdkOrder);
                    //             // console.log(field);
                    //             // console.log(field.accessor);
                    //             if (!field.Render) {
                    //               // console.log(field.accessor);
                    //               // console.log(cdkOrder[field.accessor]);
                    //             }
                    //             // return "hi";
                    //             return (
                    //               <td
                    //                 // className="cdk-table-cell"
                    //                 key={field.Header ?? field.id ?? index}
                    //                 // className="test"
                    //                 style={{
                    //                   minWidth: 0,
                    //                   width: field.width,
                    //                   flex: `${field.width} 0 auto`,
                    //                   //wordWrap gets changed to overflow-wrap in the browser
                    //                   overflowWrap:
                    //                     field.id !== "actions"
                    //                       ? "anywhere"
                    //                       : "normal", //don't want buttons to break to new line
                    //                   // wordBreak: "break-word",
                    //                   // wordBreak: "break-all", //in my opinion, after some testing, this seems to work the best - scratch that, overflowWrap: "anywhere" seems better for everything except buttons
                    //                   // backgroundColor: `rgb(0,0,255, .7)`,
                    //                 }}
                    //               >
                    //                 {field.Render
                    //                   ? field.Render(mergedOrder)
                    //                   : get(mergedOrder, field.accessor)}
                    //               </td>
                    //             );
                    //           })}
                    //         </tr>
                    //         {mergedOrder.isExpanded && (
                    //           <tr
                    //             style={{
                    //               display: "flex",
                    //             }}
                    //           >
                    //             <td
                    //               style={{
                    //                 borderTopWidth: 0,
                    //                 width: "100%",
                    //                 maxWidth: "100%",
                    //                 // border: "1px solid black",
                    //                 // width: "100%",
                    //                 // maxWidth: "fill-available",
                    //                 // overflow: "hidden",
                    //               }}
                    //             >
                    //               <CDKOrderDetailsPanel
                    //                 order={mergedOrder}
                    //                 width={tableWidth}
                    //                 jwtInfo={jwtInfo}
                    //               />
                    //             </td>
                    //           </tr>
                    //         )}
                    //       </React.Fragment>
                    //     );
                    //   })
                  }
                  {tableDataToDisplay.map((cdkOrder, index) => {
                    return (
                      <React.Fragment key={cdkOrder.CDKOrderID}>
                        <tr
                          style={{
                            display: "flex",
                            minWidth: "0px",
                            flex: "1 0 auto",
                          }}
                        >
                          {/* <td>
                    <input type="checkbox" />
                  </td>
                  <td>
                    <button className="btn btn-primary order-history-expander-button">
                      <BsPlus />
                    </button>
                  </td> */}
                          {Fields.map((field, index) => {
                            // console.log(cdkOrder);
                            // console.log(field);
                            // console.log(field.accessor);
                            if (!field.Render) {
                              // console.log(field.accessor);
                              // console.log(cdkOrder[field.accessor]);
                            }
                            // return "hi";
                            return (
                              <td
                                // className="cdk-table-cell"
                                key={field.Header ?? field.id ?? index}
                                // className="test"
                                style={{
                                  minWidth: 0,
                                  width: field.width,
                                  flex: `${field.width} 0 auto`,
                                  //wordWrap gets changed to overflow-wrap in the browser
                                  overflowWrap:
                                    field.id !== "actions"
                                      ? "anywhere"
                                      : "normal", //don't want buttons to break to new line
                                  // wordBreak: "break-word",
                                  // wordBreak: "break-all", //in my opinion, after some testing, this seems to work the best - scratch that, overflowWrap: "anywhere" seems better for everything except buttons
                                  // backgroundColor: `rgb(0,0,255, .7)`,
                                }}
                              >
                                {field.Render
                                  ? field.Render(cdkOrder)
                                  : get(cdkOrder, field.accessor)}
                              </td>
                            );
                          })}
                        </tr>
                        {cdkOrder.isExpanded && (
                          <tr
                            style={{
                              display: "flex",
                            }}
                          >
                            <td
                              style={{
                                borderTopWidth: 0,
                                width: "100%",
                                maxWidth: "100%",
                                // border: "1px solid black",
                                // width: "100%",
                                // maxWidth: "fill-available",
                                // overflow: "hidden",
                              }}
                            >
                              <CDKOrderDetailsPanel
                                order={cdkOrder}
                                width={tableWidth}
                                jwtInfo={jwtInfo}
                              />
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}
                </>
              )}
            </tbody>
          </table>
        </div>
        {
          <div className="d-flex justify-content-between px-2 mt-3">
            <div className="d-flex">
              <div>
                <DiliTextCP
                  className="mr-2"
                  inputClass="form-control-sm pagination-page-input"
                  onChange={handlePageSearchChange}
                  value={pageSearchValue}
                  type="number"
                  min={1}
                  blockScientificNotation
                  positiveOnly
                  integerOnly
                ></DiliTextCP>
                <small className="text-note pl-1">
                  Page {page} / {totalPages}
                </small>
              </div>
              <select
                className="form-control form-control-sm"
                onChange={handleChangePageSize}
                style={{ width: "fit-content" }}
              >
                <option value={10}>10 per page</option>
                <option value={20}>20 per page</option>
                <option value={30}>30 per page</option>
                <option value={40}>40 per page</option>
                <option value={50}>50 per page</option>
                {/* Kinda laggy even at lower values (mainly due to time code fetching and updating ) */}
                {/* <option value={100}>100 per page</option> */}
              </select>
            </div>
            <ul className="pagination">
              <li
                className="page-item"
                disabled={page === 1}
                onClick={() => {
                  goToPage(page - 1);
                }}
              >
                <button className="page-link">Previous</button>
              </li>
              {pageOptions
                .slice(
                  page - 1 >= 3
                    ? page - 1 >= pageOptions.length - 2
                      ? pageOptions.length - 5
                      : page - 3
                    : 0,
                  page - 1 >= 3 ? page + 2 : 5
                )
                .map((pageNumber) => {
                  // console.log(pageNumber);
                  return (
                    <li
                      key={pageNumber}
                      className={
                        "page-item " +
                        (page === pageNumber + 1 ? "active " : "")
                      }
                      onClick={() => {
                        goToPage(pageNumber + 1);
                      }}
                    >
                      <button className="page-link">{pageNumber + 1}</button>
                    </li>
                  );
                })}
              <li
                className="page-item"
                onClick={() => {
                  goToPage(page + 1);
                }}
              >
                <button className="page-link">Next</button>
              </li>
            </ul>
          </div>
        }
      </div>
    </>
  );
};
